import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  IonApp,
  IonContent,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonSplitPane,
  IonPopover,
  IonButton,
  IonModal,
  IonAlert,
  isPlatform,
} from "@ionic/react";
import { menuController } from "@ionic/core/components";
import { IonReactRouter } from "@ionic/react-router";
import { Subscriptions } from "capacitor-subscriptions";
import { EmailComposer } from "capacitor-email-composer";

import { Network } from "@capacitor/network";
import { StatusBar, Style } from "@capacitor/status-bar";
import { AppLauncher } from "@capacitor/app-launcher";
import { Toast } from "@capacitor/toast";
import { Device } from "@capacitor/device";
import { App, URLOpenListenerEvent, AppState } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { Browser } from "@capacitor/browser";
import { PushNotificationSchema, PushNotifications, Token, ActionPerformed } from "@capacitor/push-notifications";
import { FCM } from "@capacitor-community/fcm";
import { FirebaseCrashlytics } from "@capacitor-community/firebase-crashlytics";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import mixpanel from "mixpanel-browser";
import { Badge } from "@capawesome/capacitor-badge";
import { KeepAwake } from "@capacitor-community/keep-awake";

import AppStack from "./AppStack";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./Shared.css";

/* Images */
import iconClose from "./assets/Button_Close@3x.png";
import iconTickDark from "./assets/Button_Tick_Dark@3x.png";
import iconAdd from "./assets/Button_Expand_Add@3x.png";
import iconAddDark from "./assets/Button_Expand_Add_Dark@3x.png";
import responderLogo from "./assets/Logo_Responder_Star@3x.png";

/* Controllers */
import DataController from "./controllers/DataController";
import RemoteDataController from "./controllers/RemoteDataController";

import {
  IScreenProps,
  IUser,
  IGuidelineSummary,
  IGuideline,
  IAlgorithm,
  IBookmark,
  IRecentlyViewed,
  IPatientAge,
  ISignificantChange,
  IAppFeature,
  IClinicalNotice,
  IClinicalNoticeAck,
  ISignificantChangeAck,
  IPGDAck,
  IGLAck,
  ILastOpenedGuidelineVersions,
  ITrustPin,
  IStaffGroup,
  IRememberedUser,
  IPathway,
  IAppData,
  IHelpCentreItem,
  IFurtherResource,
  IPathwayData,
  IPathwayBypassNumber,
  IPathwayWhatGoesWhere,
  ICFRbyTrustItem,
  IEssentialSection,
  INotification,
  IAnnotation,
  ISubscriptionProduct,
} from "./Interfaces";

import AuthenticationController from "./controllers/AuthenticationController";

import LoginPage from "./pages/login/LoginPage";
import MenuPage from "./pages/menu/MenuPage";
import AccountPage from "./pages/account/AccountPage";
import OnboardingPage from "./pages/onboarding/OnboardingPage";
import HelpCentrePage from "./pages/help/HelpCentrePage";

import { stripHtml } from "string-strip-html";
import _ from "lodash";
import IdleTimer from "react-idle-timer";

import { format, subYears, addDays } from "date-fns";
import MessageBar from "./components/MessageBar";
import { OAuth2Client } from "@byteowls/capacitor-oauth2";

let listener: any;
let network: any;

type Props = {
  app: IScreenProps["app"];
  hostApp: IScreenProps["hostApp"];
  changeApp: (app: IScreenProps["app"]) => void;
  showLoadingScreen: (shouldShow: boolean) => void;
};
type State = {
  user: IScreenProps["user"];
  trust: IScreenProps["trust"];
  guidelineSummaries: IScreenProps["guidelineSummaries"];
  guidelineTextFinishedLoading: boolean;
  guidelinesText: { GLID: string; text: string }[];
  clinicalNoticesText: { CNID: number; text: string }[];
  algorithms: IScreenProps["algorithms"];
  algorithmOnlyGuidelineSummaries: IScreenProps["algorithmOnlyGuidelineSummaries"];
  annotations: IScreenProps["annotations"];
  trustGuidelineSummariesWithAlgorithms: IScreenProps["trustGuidelineSummariesWithAlgorithms"];
  images: IScreenProps["images"];
  bookmarks: IScreenProps["bookmarks"];
  recentlyViewed: IScreenProps["recentlyViewed"];
  finishedDownloadingAppData: boolean;
  switchingUsers: boolean;
  lastOpenedGuidelineVersions: ILastOpenedGuidelineVersions;
  patientAge: IScreenProps["patientAge"];
  features: string[];
  furtherResources: IScreenProps["furtherResources"];
  significantChanges: IScreenProps["significantChanges"];
  significantChangeAcks: IScreenProps["significantChangeAcks"];
  clinicalNotices: IScreenProps["clinicalNotices"];
  clinicalNoticeAcks: IScreenProps["clinicalNoticeAcks"];
  pgdAcks: IScreenProps["pgdAcks"];
  glAcks: IScreenProps["glAcks"];
  pathwayData: IScreenProps["pathwayData"];
  notifications: IScreenProps["notifications"];
  notificationCount: IScreenProps["notificationCount"];
  trendingSearches: IScreenProps["trendingSearches"];
  regions: IScreenProps["regions"];
  pgdTrustInfo: IScreenProps["pgdTrustInfo"];
  trustPins: IScreenProps["trustPins"];
  staffGroups: IScreenProps["staffGroups"];
  restrictedSections: IScreenProps["restrictedSections"];
  helpCentreItems: IScreenProps["helpCentreItems"];
  trustInfo: IScreenProps["trustInfo"];
  sectionColors: IScreenProps["sectionColors"];
  appNotice: IScreenProps["appNotice"];
  essentialSections: IScreenProps["essentialSections"];
  essentialsText: { essentialSectionID: string; text: string }[];
  accountModalOpenedByUser: boolean;
  addAccountLoginModalOpen: boolean;
  showAccountSwitcher: boolean;
  rememberedUsers: IRememberedUser[];
  showTemporarilyLoginNotice: boolean;
  tabBarVisible: boolean;
  fontSizeChange: IScreenProps["fontSizeChange"];
  lineHeightChange: IScreenProps["lineHeightChange"];
  selectedFontFamily: string;
  showTextToSpeech: boolean;
  textToSpeechSpeed: number;
  fontWeight: string;
  accessabilityUnderlineLinks: boolean;
  hideParaPassLinks: boolean;
  lowVisMode: boolean;
  darkMode: IScreenProps["darkMode"];
  appearance: IScreenProps["appearance"];
  showColorFilter: IScreenProps["showColorFilter"];
  filterColor: IScreenProps["filterColor"];
  freezeFirstDrugColumn: IScreenProps["freezeFirstDrugColumn"];
  keepScreenAwake: IScreenProps["keepScreenAwake"];
  keepScreenAwakeSupported: IScreenProps["keepScreenAwakeSupported"];
  networkStatus: IScreenProps["networkStatus"];
  idleTimeout: number;
  testMode: boolean;
  debugMode: boolean;
  abTestingVersion: IScreenProps["abTestingVersion"];
  messageBarText: IScreenProps["messageBarText"];
  oneMonthIOSProductID: string;
  oneMonthAndroidProductID: string;
  oneMonthProduct: IScreenProps["oneMonthProduct"];
  twelveMonthIOSProductID: string;
  twelveMonthAndroidProductID: string;
  twelveMonthProduct: IScreenProps["twelveMonthProduct"];
  purchasingState: IScreenProps["purchasingState"];
  history: any;
  showOnboarding: boolean;
  showAccountDeletionAlert: boolean;
  cfrDisclaimerModalOpen: boolean;
  pushNotificationActionUrl: string | null;
};

class SharedApp extends Component<Props, State> {
  private idleTimer: any;

  private reactRouter: React.RefObject<IonReactRouter>;

  constructor(props: Props) {
    super(props);

    this.reactRouter = React.createRef();

    // remove console.log from production
    if (process.env.NODE_ENV === "production") {
      // console.log = function(){}
    }

    var that = this;

    // intercept console logs
    // (function () {
    //     var oldLog = console.log;
    //     console.log = function (message: any) {
    //         // DO MESSAGE HERE.
    //         that.logToServer(message);
    //         oldLog.apply(console);
    //     };
    // })();

    // // intecept errors
    // if (window && !window.onerror) {
    //     window.onerror = function (errorMsg: any, url: any, lineNumber: any, column: any, errorObj: any) {
    //         that.logToServer(errorMsg);
    //         that.logToServer(errorObj);
    //         return false;
    //     }
    // }

    let oneMonthIOSProductID = "";
    let oneMonthAndroidProductID = "";
    let twelveMonthIOSProductID = "";
    let twelveMonthAndroidProductID = "";

    if (this.props.app === "iCPG") {
      if (isPlatform("ios")) {
        oneMonthIOSProductID = "1monthCPGsubscripton";
        twelveMonthIOSProductID = "12monthCPGsubscription";
      } else if (isPlatform("android")) {
        oneMonthAndroidProductID = "1month.cpg.subscription.android.v02";
        twelveMonthAndroidProductID = "12month.cpg.subscription.android.v03";
      }
    } else if (this.props.app === "CFR") {
      if (isPlatform("ios")) {
        oneMonthIOSProductID = "1month.cfrplus.subscription.ios";
        twelveMonthIOSProductID = "12month.cfrplus.subscription.ios";
      } else if (isPlatform("android")) {
        oneMonthAndroidProductID = "1month.cfrplus.subscription.android";
        twelveMonthAndroidProductID = "12month.cfrplus.subscription.android";
      }
    }

    let defaultPatientAge = DataController.getAgesObjects()[0];

    this.state = {
      user: null,
      trust: "",
      guidelineSummaries: [],
      guidelineTextFinishedLoading: false,
      guidelinesText: [],
      clinicalNoticesText: [],
      algorithms: [],
      algorithmOnlyGuidelineSummaries: [],
      annotations: [],
      trustGuidelineSummariesWithAlgorithms: [],
      images: [],
      bookmarks: [],
      recentlyViewed: [],
      finishedDownloadingAppData: false,
      switchingUsers: false,
      lastOpenedGuidelineVersions: {},
      patientAge: defaultPatientAge,
      features: [],
      furtherResources: [],
      significantChanges: [],
      significantChangeAcks: [],
      clinicalNotices: [],
      clinicalNoticeAcks: [],
      pgdAcks: [],
      glAcks: [],
      pathwayData: null,
      regions: [],
      pgdTrustInfo: null,
      trustPins: [],
      staffGroups: [],
      restrictedSections: [],
      helpCentreItems: [],
      trustInfo: [],
      sectionColors: [],
      appNotice: null,
      essentialSections: [],
      essentialsText: [],
      notifications: [],
      notificationCount: 0,
      trendingSearches: [],
      accountModalOpenedByUser: false,
      addAccountLoginModalOpen: false,
      showAccountSwitcher: false,
      rememberedUsers: [],
      showTemporarilyLoginNotice: false,
      tabBarVisible: true,
      fontSizeChange: 0,
      lineHeightChange: 0,
      selectedFontFamily: "Inter",
      showTextToSpeech: false,
      textToSpeechSpeed: 5,
      darkMode: false,
      appearance: "Auto",
      showColorFilter: false,
      filterColor: { r: 0, g: 100, b: 255, a: 0.5 },
      freezeFirstDrugColumn: false,
      keepScreenAwake: false,
      keepScreenAwakeSupported: true,
      fontWeight: "400",
      accessabilityUnderlineLinks: false,
      hideParaPassLinks: false,
      lowVisMode: false,
      networkStatus: null,
      idleTimeout: 1000 * 60 * 60,
      messageBarText: "Loading content",
      testMode: false,
      debugMode: false,
      abTestingVersion: "A",
      oneMonthIOSProductID: oneMonthIOSProductID,
      oneMonthAndroidProductID: oneMonthAndroidProductID,
      oneMonthProduct: null,
      twelveMonthIOSProductID: twelveMonthIOSProductID,
      twelveMonthAndroidProductID: twelveMonthAndroidProductID,
      twelveMonthProduct: null,
      purchasingState: null,
      history: null,
      showOnboarding: false,
      showAccountDeletionAlert: false,
      cfrDisclaimerModalOpen: false,
      pushNotificationActionUrl: null,
    };

    this.idleTimer = null;
  }

  // async logToServer(consoleMessage: any) {

  //   try {
  //     let logString = 'Test string';
  //     let userID = '0';

  //     if (this.state.user && this.state.user.uid) {
  //       userID = this.state.user.uid;
  //     }

  //     if (typeof(consoleMessage) === 'string') {
  //       logString = consoleMessage;
  //     } else if (consoleMessage.stack != null) {
  //       logString = consoleMessage.stack;
  //     } else if (consoleMessage.message != null) {
  //       logString = consoleMessage.message;
  //     }

  //     // let url = "https://aimermedia-api.co.uk/classapi/pppapi/logToServer";
  //     // let response = await fetch(url, {
  //     //   method: 'POST',
  //     //   body: JSON.stringify({
  //     //     contactID: userID,
  //     //     log: logString,
  //     //   }),
  //     //   cache: 'reload',
  //     // })

  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  //     var urlencoded = new URLSearchParams();
  //     urlencoded.append("contactID", userID);
  //     urlencoded.append("log", logString);

  //     var requestOptions: RequestInit = {
  //       method: 'POST',
  //       headers: myHeaders,
  //       body: urlencoded,
  //       redirect: 'follow'
  //     };

  //     await fetch("https://aimermedia-api.co.uk/classapi/pppapi/logToServer", requestOptions)

  //     let test = '';

  //   } catch (error) {
  //     let test = '';
  //   }
  // }

  async componentDidMount() {
    try {
      await DataController.updateAppSettings(this.props.app);
    } catch (error) {
      console.log(error);
    }

    // register firebase analytics for web version
    try {
      if ((isPlatform("ios") || isPlatform("android")) && isPlatform("mobileweb") === false) {
        // native
      } else {
        // web

        if (this.props.app === "iCPG") {
          FirebaseAnalytics.initializeFirebase({
            apiKey: "AIzaSyB8pSzRMLo3E9H_Mn-J4Ke_aTTG_BTTtm8",
            authDomain: "project-8377737033187825245.firebaseapp.com",
            databaseURL: "https://project-8377737033187825245.firebaseio.com",
            projectId: "project-8377737033187825245",
            storageBucket: "project-8377737033187825245.appspot.com",
            messagingSenderId: "1014550022657",
            appId: "1:1014550022657:web:b90ce5a91b315bc8674e00",
            measurementId: "G-B1ZX1GD4C6",
          });
        } else if (this.props.app === "Plus") {
          FirebaseAnalytics.initializeFirebase({
            apiKey: "AIzaSyC-CjK_5yOBfSfTnZuyqrVMLMRsnZR6rRo",
            authDomain: "jrcalc-plus.firebaseapp.com",
            databaseURL: "https://jrcalc-plus.firebaseio.com",
            projectId: "jrcalc-plus",
            storageBucket: "jrcalc-plus.appspot.com",
            messagingSenderId: "268865735061",
            appId: "1:268865735061:web:f8ef846f06a886a9e50e9c",
            measurementId: "G-GZNE06BQQV",
          });
        } else if (this.props.app === "CFR") {
          FirebaseAnalytics.initializeFirebase({
            apiKey: "AIzaSyB9AyIAW5jnRyGMwHQIs4OIp2L88My7KL4",
            authDomain: "community-first-responder.firebaseapp.com",
            databaseURL: "https://community-first-responder.firebaseio.com",
            projectId: "community-first-responder",
            storageBucket: "community-first-responder.appspot.com",
            messagingSenderId: "277714942445",
            appId: "1:277714942445:web:1fd15d550c636c5acf8fe4",
            measurementId: "G-YDTF4SBSV3",
          });
        }
      }

      if (this.props.app === "CFR") {
        mixpanel.init("b6cf906edc5cad85daf7dc01e53fd89e", {
          debug: true,
          track_pageview: true,
          persistence: "localStorage",
        });
      }
    } catch (error) {
      console.log(error);
    }

    if (isPlatform("desktop") || isPlatform("mobileweb")) {
      let locationHref = window.location.href;

      if (DataController.isDesktopVersion()) {
        let baseElements = document.getElementsByTagName("base");
        if (baseElements.length > 0) {
          let baseElement = baseElements[0];
          baseElement.target = "_blank";
        }

        // @ts-ignore
        let argsString = await window.electronAPI.getStartArgs();
        let args = JSON.parse(argsString);

        // alert(argsString);

        locationHref = "localhost:8100";

        let firstArgFound = false;

        for (let argIndex = 0; argIndex < args.length; argIndex++) {
          let arg = args[argIndex];
          let nextArg = null;
          if (argIndex < args.length) {
            nextArg = args[argIndex + 1];
          }

          if (
            (arg === "-user" ||
              arg === "-glid" ||
              arg === "-clid" ||
              arg === "-subsection" ||
              arg === "-table" ||
              arg === "-figure" ||
              arg === "-algid" ||
              arg === "-epcr" ||
              arg === "-trust" ||
              arg === "-url") &&
            nextArg
          ) {
            locationHref += firstArgFound ? "&" : "?";
            locationHref += arg.substr(1) + "=" + nextArg;
            firstArgFound = true;
          }
        }
      }

      this.handleAppOpenURL(locationHref);
    } else {
      App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
        this.handleAppOpenURL(event.url);
      });
    }

    document.addEventListener("ionBackButton", (ev: any) => {
      ev.detail.register(10, () => {
        // _.throttle(() => {
        this.handleIonicBackButton();
        // }, 100);
      });
    });

    // download app settings and update them (e.g. if serverUrl has been changed then it will be updated before downloading other data)
    this.downloadAppSettings();

    await DataController.makeDirectories();

    await this.setupNetworkListener();

    // get app settings
    let finishedOnboarding = await DataController.getFinishedOnboarding();
    if (this.props.app === "iCPG" || isPlatform("mobileweb") || isPlatform("desktop")) {
      finishedOnboarding = true;
    }
    await this.setStateAsync({ showOnboarding: !finishedOnboarding });

    this.getExternalCSS();
    this.getFontSize();
    this.getLineHeight();
    this.getFontFamily();
    this.getShowTextToSpeech();
    this.getTextToSpeechSpeed();
    this.configureAppearance();
    this.getShowColorFilter();
    this.getFilterColor();
    this.getFreezeFirstDrugColumn();
    this.getKeepScreenAwake();
    this.getFontWeight();
    this.getAccessabilityUnderlineLinks();
    this.getHideParaPassLinks();
    this.getABTestingVersion();

    // load saved user
    let user = await AuthenticationController.getUser();
    let testMode = false;
    if (user != null && user.OTA_DEBUG) {
      testMode = true;
    }

    let trust = "";
    if (user) {
      trust = user.trust;
    }

    let logoutOnClose = false;

    if (DataController.isDesktopVersion()) {
      let desktopConfig = await this.getDesktopConfig();

      if (desktopConfig != null) {
        if (desktopConfig.trust != null) {
          trust = desktopConfig.trust;
        }
        if (desktopConfig.idleLogoutTimer != null && typeof desktopConfig.idleLogoutTimer == "number") {
          this.setState({ idleTimeout: desktopConfig.idleLogoutTimer });
        }
        if (desktopConfig.logoutOnClose != null && desktopConfig.logoutOnClose === true) {
          logoutOnClose = true;
        }
      }
    }

    // const features = await this.getFilteredAppFeatures(testMode, trust);

    if (logoutOnClose) {
      // don't load user on desktop if they have idle logout;
      this.logout(true);
    } else {
      if (user != null) {
        this.userUpdated(user, false);
      }
      this.getRememberedUsers();

      if (user != null) {
        // user was already logged in
        this.logAppStart(user);
        try {
          RemoteDataController.logEvent("app_start_logged_in", {});
        } catch (error) {}
      }
    }

    this.props.showLoadingScreen(false);
    SplashScreen.hide();

    if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
      this.setupIAP();

      setTimeout(() => {
        this.configurePushNotifications();
      }, 3000);
    }

    setInterval(() => {
      this.loadData();
    }, 600000);
  }

  // debound method as bug in ionic where back button is triggered multiple times per single press
  handleIonicBackButton = _.debounce(() => {
    console.log("Handler was called!");
    if (this.reactRouter && this.reactRouter.current) {
      this.reactRouter.current.history.goBack();
    }
  }, 100);

  componentWillUnmount() {
    if (listener) {
      listener.remove();
    }

    if (network) {
      network.remove();
    }
  }

  async getDesktopConfig() {
    if (DataController.isDesktopVersion()) {
      try {
        // @ts-ignore
        let configString = await window.electronAPI.getConfigOptionsString();
        let config = JSON.parse(configString);

        if (config != null) {
          // alert(config);
          return config;
        }
      } catch (error) {
        console.log(error);
      }
    }

    return null;
  }

  async downloadAppSettings() {
    await RemoteDataController.downloadAppSettings();
    await DataController.updateAppSettings(this.props.app);
  }

  async logAppStart(user: IScreenProps["user"]) {
    let appVersion = await DataController.getAppVersion(this.props.app);
    RemoteDataController.logUsage(null, null, null, null, null, true, appVersion, user, this.props.app);
  }

  async userUpdated(user: null | IUser, updatePushNotifications: boolean) {
    let app = this.props.app;

    // // if app is iCPG but user has a trust - then change app to plus
    // if (app === 'iCPG' && user != null && user.trust !== '') {
    //   app = 'Plus';
    // } else if (app === 'Plus' && user != null && user.trust === '') {
    //   app = 'iCPG';
    // }

    if (user != null && user.uid) {
      if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
        await FirebaseCrashlytics.setUserId({
          userId: user.uid,
        });
      }

      FirebaseAnalytics.setUserId({ userId: user.uid });

      if (this.props.app === "CFR") {
        try {
          mixpanel.identify(user.uid);
          mixpanel.people.set("$name", user.uid);
        } catch (error) {
          console.log(error);
        }
      }

      let analyticsTrust = "No Trust";
      if (user.trust && user.trust !== "") {
        analyticsTrust = user.trust;
      }
      RemoteDataController.setUserProperty("userTrust", analyticsTrust);
      RemoteDataController.setUserProperty("singleSignOn", user.isSSO ? "true" : "false");

      let cfrDisclaimerDismissed = true;
      if (this.props.app === "CFR") {
        cfrDisclaimerDismissed = await DataController.getCFRDisclaimerDismissed();
      }
      this.setState({ cfrDisclaimerModalOpen: !cfrDisclaimerDismissed });
    } else if (user == null) {
      if (this.props.app === "CFR") {
        try {
          mixpanel.reset();
        } catch (error) {
          console.log(error);
        }
      }
    }

    if (this.state.user == null && user != null && user.isTemporary) {
      setTimeout(() => {
        this.setState({ showTemporarilyLoginNotice: true });
      }, 500);
    }

    let testMode = await DataController.getTestMode();
    if (user != null && user.OTA_DEBUG) {
      testMode = user.OTA_DEBUG;
    }
    this.getDebugMode();

    let trust = "";
    if (user) {
      trust = user.trust;
    }

    if (this.state.user != null && this.state.user?.uid !== user?.uid) {
      // different user
      this.clearPatientAge();
      await DataController.clearAcknowledgements();
    }

    this.setState({ user: user, testMode, trust }, () => {
      // switch back to host app
      if (user == null || user.isTemporary) {
        this.props.changeApp(this.props.hostApp);
      }

      this.loadData();
      this.showAddAccountLoginModal(false);
      this.showAccountSwitcher(false);
      if (updatePushNotifications) {
        if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
          this.updatePushNotificationTopics();
        }
      }
      if (this.state.pushNotificationActionUrl != null) {
        this.handleAppOpenURL(this.state.pushNotificationActionUrl);
        this.setState({ pushNotificationActionUrl: null });
      }
    });
  }

  async loadData() {
    if (this.state.user != null) {
      // load local data
      try {
        await this.loadLocalData(true);
      } catch (error) {
        console.log("error loading local data:" + error);
      }

      // download updates
      this.setState({ messageBarText: "Checking for updates..." });

      this.processGuidelineText();
      this.processClinicalNoticeText();

      try {
        await this.downloadUpdates();
        await this.loadLocalData(false);
        // currently downloading guidelines and images separately as it takes a long time and means rest of data can't be displayed
        await RemoteDataController.downloadGuidelinesAndImages(this.state.user.trust, this.props.app);
      } catch (error) {
        console.log("error downloading updates:" + error);
      }

      // load local data again to get anything that was updated
      // this.setState({messageBarText: 'Loading Local Data'});
      await this.loadLocalData(false);

      this.setState({ messageBarText: "You're up to date" });

      setTimeout(() => {
        this.setState({ messageBarText: "" });
      }, 5000);

      this.processGuidelineText();
      this.processClinicalNoticeText();
      if (this.props.app === "CFR") {
        this.processEssentialsText();
      }
    }
  }

  async loadLocalData(initialLoad: boolean) {
    let trust = "";
    if (this.state.user) {
      trust = this.state.user.trust;
    }

    let guidelineSummaries = await DataController.getGuidelineSummaries(trust, this.props.app);
    let algorithms = await DataController.getAlgorithms();
    let algorithmOnlyGuidelineSummaries = [];
    let annotations = await DataController.getAnnotations(trust, this.state.testMode);
    let pathwayData = await DataController.getPathwayData(trust, this.state.testMode);
    let allSignificantChanges = await DataController.getSignificantChanges();
    let significantChangeAcks = await DataController.getSignificantChangeAcks();
    let furtherResources = await DataController.getFurtherResources();
    let clinicalNotices = await DataController.getClinicalNotices(trust, this.state.testMode);
    let clinicalNoticeAcks = await DataController.getClinicalNoticeAcks();
    let pgdAcks = await DataController.getPGDAcks();
    let glAcks = await DataController.getGLAcks();
    let pgdTrustInfo = await DataController.getPGDTrustInfo(trust);
    let trustPins = await DataController.getTrustPins(trust, this.state.testMode, this.props.app);
    let regions = await DataController.getRegions(trust, this.state.testMode);
    let staffGroups = await DataController.getStaffGroups(trust, this.state.testMode);
    let restrictedSections = await DataController.getRestrictedSections(trust, this.state.testMode);
    let helpCentreItems = await DataController.getHelpCentreItems();
    let trustInfo = await DataController.getTrustInfo();
    let sectionColors = await DataController.getSectionColors();
    let appNotices = await DataController.getAppNotices();
    let trendingSearches = await DataController.getTrendingSearches(trust, this.state.testMode);

    await this.updateNotificationsCount();

    let cfrByTrustItems: ICFRbyTrustItem[] = [];
    let essentialSections: IEssentialSection[] = [];

    if (this.props.app === "CFR") {
      cfrByTrustItems = await DataController.getCFRbyTrustItems(this.state.testMode);
      essentialSections = await DataController.getEssentialSections();
    }

    let bookmarks = await DataController.getAllBookmarks();
    let recentlyViewed = await DataController.getRecentlyViewed();

    let lastOpenedGuidelineVersions = await DataController.getLastOpenedGuidelineVersions(trust, this.props.app);

    // filter app features
    const features: string[] = await this.getFilteredAppFeatures(this.state.testMode, trust);

    // load local images - don't wait as it can take a while on android
    this.loadLocalImages(
      guidelineSummaries,
      algorithms,
      pathwayData,
      annotations,
      furtherResources,
      trustPins,
      helpCentreItems
    );

    // remove added properties on guideline summaries - as they appear to be kept even when reimporting
    for (let guidelineSummary of guidelineSummaries) {
      delete guidelineSummary.annotations;
      delete guidelineSummary.informationOnly;
    }

    // remove added properties on algorithms
    for (let algorithm of algorithms) {
      delete algorithm.annotations;
    }

    // remove added properties on clinicalNotices
    for (let clinicalNotice of clinicalNotices) {
      delete clinicalNotice.informationOnly;
    }

    // remove guidelines in CFR
    if (this.props.app === "CFR") {
      // loop through guidelineSummaries backwards to make it easier to remove guidelines which are hidden
      for (
        let guidelineSummaryIndex = guidelineSummaries.length - 1;
        guidelineSummaryIndex >= 0;
        guidelineSummaryIndex--
      ) {
        let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];
        let matchingCFRByTrustItem = cfrByTrustItems.find(
          (cfrByTrustItem) => cfrByTrustItem.Notes === guidelineSummary.GLID
        );

        let matchingCFRByTrustAlgorithm = cfrByTrustItems.find((cfrByTrustItem) =>
          cfrByTrustItem.Notes.includes(guidelineSummary.GLID + "-")
        );

        let shouldRemoveGuideline = true;

        let trustName = trust === "SECAMB" ? "SECAmb" : trust;
        let trustNameIncluded = `Include for ${trustName}?`;

        if (matchingCFRByTrustItem != null) {
          if (trust !== "") {
            if (matchingCFRByTrustItem[trustNameIncluded] === true) {
              shouldRemoveGuideline = false;
            }
          } else {
            if (matchingCFRByTrustItem["Include in classic CFR app?"] === true) {
              shouldRemoveGuideline = false;
            }
          }
        }

        if (matchingCFRByTrustAlgorithm != null) {
          if (trust !== "") {
            if (matchingCFRByTrustAlgorithm[trustNameIncluded] === true) {
              algorithmOnlyGuidelineSummaries.push(guidelineSummary);
            }
          } else {
            if (matchingCFRByTrustAlgorithm["Include in classic CFR app?"] === true) {
              algorithmOnlyGuidelineSummaries.push(guidelineSummary);
            }
          }
        }

        if (shouldRemoveGuideline) {
          // should remove guideline summary for this trust
          guidelineSummaries.splice(guidelineSummaryIndex, 1);
        }
      }
    }

    // remove guidelines summaries that are part of a restricted section the user doesn't have permission for
    for (let restrictedSection of restrictedSections) {
      if (this.state.user) {
        let matchingStaffGroups = _.intersection(restrictedSection.SG, this.state.user.staffGroups);
        if (matchingStaffGroups.length === 0) {
          // user not allowed to access guidelines with this section
          // loop through guidelineSummaries backwards to make it easier to remove guidelines
          for (
            let guidelineSummaryIndex = guidelineSummaries.length - 1;
            guidelineSummaryIndex >= 0;
            guidelineSummaryIndex--
          ) {
            let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];
            let guidelineSummarySections = guidelineSummary.Section.split(", ");
            if (guidelineSummarySections.includes(restrictedSection.name)) {
              guidelineSummaries.splice(guidelineSummaryIndex, 1);
            }
          }
        }
      }
    }

    // remove shared procedures from iCPG as they are not JRCALC
    if (this.props.app === "iCPG") {
      // loop through guidelineSummaries backwards to make it easier to remove guidelines which are hidden
      for (
        let guidelineSummaryIndex = guidelineSummaries.length - 1;
        guidelineSummaryIndex >= 0;
        guidelineSummaryIndex--
      ) {
        let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];

        let shouldRemoveGuideline = DataController.isSharedProcedure(guidelineSummary);
        if (shouldRemoveGuideline) {
          // should remove guideline summary
          guidelineSummaries.splice(guidelineSummaryIndex, 1);
        }
      }
    }

    let userStaffGroups: string[] = [];
    if (this.state.user) {
      userStaffGroups = this.state.user.staffGroups;
    }

    // make changes to guideline summaries (looping through backward to make easier to delete if needed)
    for (
      let guidelineSummaryIndex = guidelineSummaries.length - 1;
      guidelineSummaryIndex >= 0;
      guidelineSummaryIndex--
    ) {
      let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];
      guidelineSummary.updated = true;

      if (guidelineSummary.GLID === "NEAS0500") {
        let test = "";
      }

      // mark pgd guideline summaries which aren't part of users staff group as information only (if no staff group then not information only)
      if (guidelineSummary.GuidelineType && DataController.isAuthorisableGuideline(guidelineSummary)) {
        if (guidelineSummary.SG) {
          // if staff group isn't specificed then it's for everyone

          // if pgd or trust has no authorisation then it shouldn't be marked informationonly
          if (
            guidelineSummary.PGDType === "NoAuth" ||
            (pgdTrustInfo != null &&
              pgdTrustInfo.authorisationType === "No Authorisation or Dashboard" &&
              guidelineSummary.PGDType == null)
          ) {
            // pgd has no authorisation
            let test = "";
          } else {
            let guidelineStaffGroups = guidelineSummary.SG.replace(/, /g, ",").split(",");

            // if any user staff groups and guideline staff groups match then they have access to this guideline
            let pgdIsForUser = userStaffGroups.some((r) => guidelineStaffGroups.includes(r));

            if (guidelineSummary.GLID === "LAS1330") {
              let test = "";
            }

            if (!pgdIsForUser) {
              guidelineSummary.informationOnly = true;
            }
          }
        }
      }
    }

    // add annotations to algorithms and guidelineSummaries (makes easier to pass round the app) and remove guideline summaries which should be hidden
    for (let annotation of annotations) {
      if (annotation.Reference == null) {
        continue;
      }

      let annotationReferenceParts = annotation.Reference.split(" - ");
      let annotationGLID = "";
      if (annotationReferenceParts.length > 0) {
        annotationGLID = annotationReferenceParts[0];
      }

      let annotationFound = false;

      // loop through guidelineSummaries backwards to make it easier to remove guidelines which are hidden
      for (
        let guidelineSummaryIndex = guidelineSummaries.length - 1;
        guidelineSummaryIndex >= 0;
        guidelineSummaryIndex--
      ) {
        let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];

        if (guidelineSummary.GLID === annotationGLID) {
          annotationFound = true;

          if (guidelineSummary.annotations) {
            guidelineSummary.annotations.push(annotation);
          } else {
            guidelineSummary.annotations = [annotation];
          }

          if (annotation["Hide JRCALC?"] && annotationReferenceParts.length < 3) {
            // should remove guideline summary for this trust
            guidelineSummaries.splice(guidelineSummaryIndex, 1);
          }
        }
      }

      // loop through algorithms backwards to make it easier to remove algorithms which are hidden
      for (let algorithmIndex = algorithms.length - 1; algorithmIndex >= 0; algorithmIndex--) {
        let algorithm = algorithms[algorithmIndex];

        if (algorithm.id === annotationGLID) {
          annotationFound = true;

          if (algorithm.annotations) {
            algorithm.annotations.push(annotation);
          } else {
            algorithm.annotations = [annotation];
          }

          if (annotation["Hide JRCALC?"] && annotationReferenceParts.length < 3) {
            // should remove guideline summary for this trust
            algorithms.splice(algorithmIndex, 1);
          }
        }
      }
    }

    // check each page for age guideline to see if it has any drug annotations
    let agesObjects = DataController.getAgesObjects();

    for (
      let guidelineSummaryIndex = guidelineSummaries.length - 1;
      guidelineSummaryIndex >= 0;
      guidelineSummaryIndex--
    ) {
      let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];

      if (DataController.isPageForAge(guidelineSummary.GLID)) {
        let guideline = await DataController.getGuideline(guidelineSummary);

        let patientAgeForPageForAge = agesObjects.find((anAge) => anAge.PFA === guidelineSummary.GLID);

        if (guideline != null) {
          for (let annotation of annotations) {
            if (annotation.ID === "0") {
              continue;
            }

            if (annotation.Age && annotation.Age !== "") {
              if (patientAgeForPageForAge == null || patientAgeForPageForAge.range !== annotation.Age) {
                continue;
              } else {
                let test = "";
              }
            }

            let annotationIsForDrugTable = DataController.isAnnotationForDrugTable(annotation, guideline);

            if (annotationIsForDrugTable) {
              if (guidelineSummary.annotations) {
                guidelineSummary.annotations.push(annotation);
              } else {
                guidelineSummary.annotations = [annotation];
              }
            }
          }
        }
      }
    }

    // filter out clinicalNotices which aren't for user
    if (this.state.user) {
      for (let clinicalNoticeIndex = clinicalNotices.length - 1; clinicalNoticeIndex >= 0; clinicalNoticeIndex--) {
        let clinicalNotice = clinicalNotices[clinicalNoticeIndex];
        let shouldRemove = false;

        try {
          if (clinicalNotice.regions && clinicalNotice.regions !== "") {
            let clinicalNoticeRegions = clinicalNotice.regions.trim().split(",");
            let matchingRegions = _.intersection(clinicalNoticeRegions, this.state.user.regions);
            if (matchingRegions.length === 0) {
              shouldRemove = true;
            }
          }
          if (clinicalNotice["pgd permissions"] && clinicalNotice["pgd permissions"] !== "") {
            let clinicalNoticePgdPermissions = clinicalNotice["pgd permissions"].trim().split(",");
            let matchingPermissions = _.intersection(clinicalNoticePgdPermissions, this.state.user.staffGroups);
            if (matchingPermissions.length === 0) {
              clinicalNotice.informationOnly = true;
              if (features.includes("clinicalNoticeStaffGroupHidden")) {
                shouldRemove = true;
              }
            }
          }

          if (shouldRemove) {
            clinicalNotices.splice(clinicalNoticeIndex, 1);
          }
        } catch (error) {}
      }
    }

    // remove unacknowledged significant changes older than a year or guideline was removed
    let significantChanges: ISignificantChange[] = [];
    let now = new Date();
    let oneYearAgo = subYears(now, 1);
    for (let significantChange of allSignificantChanges) {
      let shouldAddSignificantChange = false;

      let updatedDate = new Date(significantChange.updated.dateObject);
      if (updatedDate > oneYearAgo) {
        shouldAddSignificantChange = true;
      } else {
        let significantChangeAck = significantChangeAcks.find(
          (significantChangeAck) => significantChangeAck.cnid === significantChange.id
        );
        if (significantChangeAck != null) {
          shouldAddSignificantChange = true;
        }
      }

      if (shouldAddSignificantChange) {
        let matchingGuidelineSummary = guidelineSummaries.find(
          (guidelineSummary) => guidelineSummary.GLID === significantChange.GLID
        );
        if (matchingGuidelineSummary) {
          significantChanges.push(significantChange);
        }
      }
    }

    // remove algorithms if guideline is not available
    if (features.includes("hideAlgorithms")) {
      // loop through algorithms backwards to make it easier to remove algorithms
      for (let algorithmIndex = algorithms.length - 1; algorithmIndex >= 0; algorithmIndex--) {
        let algorithm = algorithms[algorithmIndex];

        let matchingGuidelineSummary = guidelineSummaries.find(
          (guidelineSummary) => guidelineSummary.GLID === algorithm.GLID
        );

        let matchingAlgorithmOnlyGuidelineSummary = algorithmOnlyGuidelineSummaries.find(
          (guidelineSummary) => guidelineSummary.GLID === algorithm.GLID
        );

        if (matchingGuidelineSummary == null && matchingAlgorithmOnlyGuidelineSummary == null) {
          // should remove algorithms
          algorithms.splice(algorithmIndex, 1);
        }
      }
    }

    let trustGuidelineSummariesWithAlgorithms = guidelineSummaries.filter(
      (guidelineSummary) => guidelineSummary.trust && guidelineSummary.Section.includes("ALG")
    );
    trustGuidelineSummariesWithAlgorithms.sort((a, b) => (a.Title.toLowerCase() > b.Title.toLowerCase() ? 1 : -1));

    // add guidelines to further resources that are marked as FurtherResourceOnly
    for (
      let guidelineSummaryIndex = guidelineSummaries.length - 1;
      guidelineSummaryIndex >= 0;
      guidelineSummaryIndex--
    ) {
      let guidelineSummary = guidelineSummaries[guidelineSummaryIndex];
      if (
        guidelineSummary.Section.includes("FurtherReourcesOnly") ||
        guidelineSummary.Section.includes("FurtherResourcesOnly")
      ) {
        let furtherResource: IFurtherResource = {
          name: guidelineSummary.Title,
          products: ["ALL"],
          resourceID: 9999,
          trusts: ["ALL"],
          type: "guideline",
          lastModified: now.toISOString(),
          GLID: guidelineSummary.GLID,
          enabled: true,
          iconUrl: undefined,
          iconFileName: undefined,
          link: undefined,
          iosAppLink: undefined,
          iosDeepLink: undefined,
          androidPackage: undefined,
          googlePlayLink: undefined,
        };

        furtherResources.push(furtherResource);
      }
    }

    // remove pathways which aren't for user
    // loop through pathways backwards to make them easier to remove
    try {
      if (pathwayData) {
        for (let pathwayIndex = pathwayData.Pathways.length - 1; pathwayIndex >= 0; pathwayIndex--) {
          let pathway = pathwayData.Pathways[pathwayIndex];
          if (pathway.fields["Only visible to"] && this.state.user) {
            let matchingPermissions = _.intersection(pathway.fields["Only visible to"], this.state.user.staffGroups);
            if (matchingPermissions.length === 0) {
              pathwayData.Pathways.splice(pathwayIndex, 1);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }

    // remove section colors which are not for trust
    // loop through algorithms backwards to make it easier to remove algorithms
    for (let sectionColorIndex = sectionColors.length - 1; sectionColorIndex >= 0; sectionColorIndex--) {
      let sectionColor = sectionColors[sectionColorIndex];

      let matchingTrust = sectionColor.trusts.includes(trust) || sectionColor.trusts.includes("ALL");

      if (matchingTrust == false) {
        // should remove sectionColor
        sectionColors.splice(sectionColorIndex, 1);
      }
    }

    // get latest app notice
    try {
      for (let appNoticeIndex = 0; appNoticeIndex < appNotices.length; appNoticeIndex++) {
        let appNotice = appNotices[appNoticeIndex];

        if (appNotice.products.includes(this.props.app) || appNotice.products.includes("ALL")) {
          if (appNotice.trusts.includes("ALL")) {
            this.setState({ appNotice: appNotice });
            break;
          } else if (this.state.user != null && appNotice.trusts.includes(this.state.user.trust)) {
            this.setState({ appNotice: appNotice });
            break;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }

    this.setState({
      guidelineSummaries,
      algorithms,
      algorithmOnlyGuidelineSummaries,
      annotations,
      trustGuidelineSummariesWithAlgorithms,
      bookmarks,
      recentlyViewed,
      lastOpenedGuidelineVersions,
      significantChanges,
      significantChangeAcks,
      clinicalNotices,
      clinicalNoticeAcks,
      pgdAcks,
      glAcks,
      pgdTrustInfo,
      sectionColors,
      trustPins,
      regions,
      staffGroups,
      restrictedSections,
      helpCentreItems,
      trustInfo,
      features,
      furtherResources,
      pathwayData,
      essentialSections,
      trendingSearches,
    });
  }

  async loadLocalImages(
    guidelineSummaries: IGuidelineSummary[],
    algorithms: IAlgorithm[],
    pathwayData: IPathwayData | null,
    annotations: IAnnotation[],
    furtherResources: IFurtherResource[],
    trustPins: ITrustPin[],
    helpCentreItems: IHelpCentreItem[]
  ) {
    let trust = "";
    if (this.state.user) {
      trust = this.state.user.trust;
    }

    let images = await DataController.getImages(guidelineSummaries, algorithms, pathwayData, annotations, trust);
    let furtherResourceImages = await DataController.getImagesForFurtherResources(furtherResources);
    let trustPinImages = await DataController.getImagesForTrustPins(trustPins);
    let helpCentreImages = await DataController.getImagesForHelpCentreItems(helpCentreItems);

    // add images together
    images = images.concat(furtherResourceImages);
    images = images.concat(trustPinImages);
    images = images.concat(helpCentreImages);

    this.setState({ images });
  }

  async downloadUpdates() {
    let trust = "";
    if (this.state.user != null) {
      trust = this.state.user.trust;
    }

    try {
      if (this.state.networkStatus && this.state.networkStatus.connected) {
        // download general data
        await RemoteDataController.downloadAppFeatures(this.state.testMode);
        const features = await this.getFilteredAppFeatures(this.state.testMode, trust);

        await RemoteDataController.downloadGuidelineSummaryUpdates(this.state.testMode);
        await RemoteDataController.downloadTrustGuidelineSummaryUpdates(trust, this.state.testMode);
        await RemoteDataController.downloadAlgorithms(this.state.testMode);
        await RemoteDataController.downloadAnnotations(trust, this.state.testMode, this.props.app);
        await RemoteDataController.downloadAnnotationImages(trust, this.state.testMode);
        await RemoteDataController.downloadFurtherResources(this.state.testMode);
        if (features.includes("pathwaysTab")) {
          await RemoteDataController.downloadPathwayData(trust, this.state.testMode);
          await RemoteDataController.downloadPathwayImages(trust, this.state.testMode);
        }
        await RemoteDataController.downloadTrustPins(trust, this.state.testMode);
        await RemoteDataController.downloadRegions(trust, this.state.testMode);
        await RemoteDataController.downloadStaffGroups(trust, this.state.testMode);
        await RemoteDataController.downloadRestrictedSections(trust, this.state.testMode);
        await RemoteDataController.downloadHelpCentreItems(this.state.testMode);
        await RemoteDataController.downloadTrustInfo(this.state.testMode);
        await RemoteDataController.downloadPGDTrustInfo();
        await RemoteDataController.downloadExternalCSS();
        await RemoteDataController.downloadSectionColors(this.state.testMode);
        await RemoteDataController.downloadAppNotices(this.state.testMode);
        await RemoteDataController.downloadParaPassGuidelineQuizList();
        if (this.props.app === "CFR") {
          await RemoteDataController.downloadCFRbyTrustItems(this.state.testMode);
          await RemoteDataController.downloadCFRGuidelineSummaryUpdates(trust, this.state.testMode);
        }

        // download user specific data
        if (this.state.user) {
          await this.downloadAndUpdateUserInfo();
          await RemoteDataController.sendRemoteQueue();
          await this.syncAppData();

          await RemoteDataController.downloadClinicalNotices(this.state.user, this.props.app, this.state.testMode);
          await RemoteDataController.downloadClinicalNoticeAcks(this.state.user, this.props.app);
          await RemoteDataController.downloadSignificantChanges(this.state.user, this.props.app, this.state.testMode);
          await RemoteDataController.downloadSignificantChangeAcks(this.state.user);
          await RemoteDataController.downloadPGDAcks(this.state.user);
          await RemoteDataController.downloadGLAcks(this.state.user, this.props.app);
          await RemoteDataController.downloadNotifications(this.state.user, this.props.app);
          await RemoteDataController.downloadTrendingSearches(this.state.user, this.props.app, this.state.testMode);
        }
      } else {
        Toast.show({
          text: "No internet - Can't load latest updates",
          duration: "long",
        }).then(() => {});
      }
    } catch (error) {
      console.log(error);
    }
  }

  async downloadAndUpdateUserInfo() {
    if (this.state.user) {
      try {
        let user = await AuthenticationController.downloadUserInfo(this.state.user, this.props.app);
        if (user != null) {
          if (this.state.user != null && this.state.user.uid === user.uid) {
            let trust = user.trust;
            await this.setStateAsync({ user, trust });
          }
        }
      } catch (error) {
        console.log(error);
        if (error === "unauthorised") {
          await this.setStateAsync({ user: null, trust: "" });
        }
      }
    }
  }

  setupNetworkListener() {
    Network.getStatus().then((status) => {
      this.setState({
        networkStatus: status,
      });
    });

    network = Network.addListener("networkStatusChange", (status) => {
      this.setState({
        networkStatus: status,
      });
    });
  }

  async handleAppOpenURL(url: string) {
    await this.waitForRouterToLoad();

    if (this.reactRouter && this.reactRouter.current && this.reactRouter.current.history != null) {
      let updatedUrl = url.replace(/#\//g, "");
      updatedUrl = updatedUrl.replace(/@/g, "&");

      const parsedUrl = new URL(updatedUrl);
      let GLID = parsedUrl.searchParams.get("GLID");
      if (GLID == null) {
        GLID = parsedUrl.searchParams.get("glid");
      }
      let CLID = parsedUrl.searchParams.get("CLID");
      if (CLID == null) {
        CLID = parsedUrl.searchParams.get("clid");
      }
      let subsection = parsedUrl.searchParams.get("subsection");
      if (subsection == null) {
        subsection = parsedUrl.searchParams.get("Subsection");
      }
      let table = parsedUrl.searchParams.get("table");
      if (table == null) {
        table = parsedUrl.searchParams.get("Table");
      }
      let figure = parsedUrl.searchParams.get("figure");
      if (figure == null) {
        figure = parsedUrl.searchParams.get("Figure");
      }
      let algID = parsedUrl.searchParams.get("algid");
      if (algID == null) {
        algID = parsedUrl.searchParams.get("Algid");
      }
      let ePCR = parsedUrl.searchParams.get("ePCR");
      if (ePCR == null) {
        ePCR = parsedUrl.searchParams.get("epcr");
      }
      let trust = parsedUrl.searchParams.get("trust");
      if (trust == null) {
        trust = parsedUrl.searchParams.get("Trust");
      }
      let userName = parsedUrl.searchParams.get("user");
      if (userName == null) {
        userName = parsedUrl.searchParams.get("User");
      }
      let urlParam = parsedUrl.searchParams.get("url");
      if (urlParam == null) {
        urlParam = parsedUrl.searchParams.get("URL");
      }
      let externalUrlParam = parsedUrl.searchParams.get("ExternalUrl");
      if (externalUrlParam == null) {
        externalUrlParam = parsedUrl.searchParams.get("ExternalURL");
      }

      let universalLinkParam = null;
      if (url.includes("?") === false) {
        // if includes ? then it should be handled by other url parameters instead
        if (this.props.app === "iCPG") {
          if (updatedUrl.includes("icpgweb.co.uk")) {
            universalLinkParam = updatedUrl.substring(updatedUrl.indexOf("icpgweb.co.uk") + 13);
          }
        } else if (this.props.app === "Plus") {
          if (updatedUrl.includes("jrcalcplusweb.co.uk")) {
            universalLinkParam = updatedUrl.substring(updatedUrl.indexOf("jrcalcplusweb.co.uk") + 19);
          }
        }
      }

      let params: { [key: string]: any } = {};

      if (subsection) {
        params.subsection = subsection;
      }
      if (table) {
        params.table = table;
      }
      if (figure) {
        params.figure = figure;
      }
      if (ePCR) {
        params.ePCR = ePCR;
      }
      if (trust) {
        params.trust = trust;
      }

      if (userName) {
        let testMode = false;
        if (this.state.user != null && this.state.user.OTA_DEBUG) {
          testMode = true;
        }

        let trust = "";
        if (this.state.user) {
          trust = this.state.user.trust;
        }

        if (DataController.isDesktopVersion()) {
          try {
            // @ts-ignore
            let configString = await window.electronAPI.getConfigOptionsString();
            let config = JSON.parse(configString);

            if (config != null) {
              // alert(config);
              if (config.trust != null) {
                trust = config.trust;
              }
            }
          } catch (error) {
            console.log(error);
          }
        }

        const features = await this.getFilteredAppFeatures(testMode, trust);

        let eprsLogin = false;
        let eprsOnlineLookupLogin = false;

        if (DataController.isDesktopVersion()) {
          let desktopConfig = await this.getDesktopConfig();

          if (desktopConfig != null) {
            if (desktopConfig.EPRS != null && desktopConfig.EPRS === true) {
              eprsLogin = true;
            }
            if (desktopConfig.EPRSOnlineLookup != null && desktopConfig.EPRSOnlineLookup === true) {
              eprsOnlineLookupLogin = true;
            }
          }
        }

        if ((DataController.isDesktopVersion() && eprsLogin) || eprsOnlineLookupLogin) {
          try {
            let user = await AuthenticationController.logInAsDesktopUser(
              userName,
              trust,
              eprsOnlineLookupLogin,
              this.props.app
            );
            if (user != null) {
              await this.userUpdated(user, true);
              await new Promise((resolve) => setTimeout(resolve, 3000)); // wait 3 seconds before trying to navigate to any further guidelines
            }
          } catch (error: any) {
            console.log(error);
            if (error.failedDesktopLogin) {
              this.logout(true);
              alert("Username not found.");
            }
          }
        }
      }

      await this.waitForContentsToLoad();

      if (universalLinkParam) {
        this.reactRouter.current.history.push(universalLinkParam);
      } else if (externalUrlParam) {
        Browser.open({ url: externalUrlParam });
      } else if (urlParam) {
        this.reactRouter.current.history.push(urlParam);
      } else if (algID) {
        this.navigateToAlgorithm(algID, "", this.reactRouter.current.history, "Deeplink");
      } else if (GLID) {
        this.navigateToGuideline(GLID, "", this.reactRouter.current.history, params, "Deeplink");
      } else if (CLID) {
        this.navigateToClinicalNotice(parseInt(CLID), "", this.reactRouter.current.history, null, "Deeplink");
      }
    }
  }

  setAppHistory(history: any) {
    // used so that history can be accessed from SharedApp for navigating
    this.setState({ history: history });

    FirebaseAnalytics.setScreenName({ screenName: "Dashboard Tab" });

    history.listen((location: any, action: any) => {
      try {
        if (location != null && location.pathname != null) {
          if (location.state != null && location.state.page != null) {
            FirebaseAnalytics.setScreenName({ screenName: location.state.page });
          } else {
            let page = location.pathname;

            if (location.pathname === "/dashboard") {
              page = "Dashboard Tab";
            } else if (location.pathname === "/guidelines") {
              page = "Guidelines Tab";
            } else if (location.pathname === "/meds") {
              page = "Meds Tab";
            } else if (location.pathname === "/algorithms") {
              page = "Algorithms Tab";
            } else if (location.pathname === "/pageforage") {
              page = "Page For Age Tab";
            } else if (location.pathname === "/pathways") {
              page = "Pathways Tab";
            }
            FirebaseAnalytics.setScreenName({ screenName: page });
          }
        }
      } catch (error) {
        console.log("error logging analytics");
      }
    });
  }

  showAccountModal(shouldShow: boolean) {
    this.setState({ accountModalOpenedByUser: shouldShow });
  }

  showAddAccountLoginModal(shouldShow: boolean) {
    this.setState({ addAccountLoginModalOpen: shouldShow });
  }

  async getRememberedUsers() {
    let rememberedUsers = await AuthenticationController.getRememberedUsers();
    this.setState({ rememberedUsers: rememberedUsers });
  }

  async showAccountSwitcher(shouldShow: boolean) {
    if (shouldShow) {
      let rememberedUsers = await AuthenticationController.getRememberedUsers();
      this.setState({ rememberedUsers: rememberedUsers });
    }

    this.setState({ showAccountSwitcher: shouldShow });
  }

  async switchAccount(rememberedUser: IRememberedUser, trust: string) {
    if (this.state.switchingUsers === true) {
      return;
    }
    try {
      this.setState({ switchingUsers: true });

      await AuthenticationController.clearUserData();
      this.clearPatientAge();

      this.props.changeApp(this.props.hostApp);

      this.setState({ finishedDownloadingAppData: false });

      let user = await AuthenticationController.getUserForRememberedUser(rememberedUser, trust, this.props.app);
      this.userUpdated(user, false);

      if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
        setTimeout(() => {
          this.updatePushNotificationTopics();
        }, 1000);
      }

      RemoteDataController.logEvent("account_switched", {});
    } catch (error) {
      console.log("error switching accounts - " + error);
    } finally {
      this.setState({ switchingUsers: false });
    }
  }

  showHelpCentre() {
    if (this.reactRouter && this.reactRouter.current && this.reactRouter.current.history != null) {
      this.reactRouter.current.history.push(`/dashboard/helpcentre`, { page: "Help Centre" });
      menuController.close();
    }
  }

  showContactPage() {
    if (this.reactRouter && this.reactRouter.current && this.reactRouter.current.history != null) {
      this.reactRouter.current.history.push(`/dashboard/contact`, { page: "Contact Us" });
      menuController.close();
    }
  }

  async getFilteredAppFeatures(testMode: boolean, trust: string) {
    const allAppFeatures = await DataController.getAppFeatures();

    let features: string[] = [];

    for (let appFeatureIndex = 0; appFeatureIndex < allAppFeatures.length; appFeatureIndex++) {
      let appFeature = allAppFeatures[appFeatureIndex];

      if (appFeature.iCPGTesting !== undefined) {
        // updated app features format
        if (this.props.app === "iCPG") {
          if (appFeature.iCPGLive === true && !testMode) {
            features.push(appFeature.name);
          } else if (appFeature.iCPGTesting === true && testMode) {
            features.push(appFeature.name);
          }
        } else if (this.props.app === "Plus") {
          if (
            appFeature.plusLive &&
            !testMode &&
            (appFeature.plusLive.includes(trust) || appFeature.plusLive.includes("ALL"))
          ) {
            features.push(appFeature.name);
          } else if (
            appFeature.plusTesting &&
            testMode &&
            (appFeature.plusTesting.includes(trust) || appFeature.plusTesting.includes("ALL"))
          ) {
            features.push(appFeature.name);
          }
        } else if (this.props.app === "CFR") {
          if (appFeature.cfrLive && !testMode) {
            // Live
            if (
              appFeature.cfrLive.includes("ALL") ||
              appFeature.cfrLive.includes(trust) ||
              (trust !== "" && appFeature.cfrLive.includes("ALL TRUSTS")) ||
              (trust === "" && appFeature.cfrLive.includes("NON TRUST USERS"))
            ) {
              features.push(appFeature.name);
            }
          } else if (appFeature.cfrTesting && testMode) {
            // Testing
            if (
              appFeature.cfrTesting.includes("ALL") ||
              appFeature.cfrTesting.includes(trust) ||
              (trust !== "" && appFeature.cfrTesting.includes("ALL TRUSTS")) ||
              (trust === "" && appFeature.cfrTesting.includes("NON TRUST USERS"))
            ) {
              features.push(appFeature.name);
            }
          }
        }
      } else {
        // old app features format
        if ((testMode && appFeature.testing) || (!testMode && appFeature.live)) {
          if (appFeature.products.includes(this.props.app) || appFeature.products.includes("ALL")) {
            if (appFeature.trusts.includes("ALL")) {
              features.push(appFeature.name);
            } else if (trust != null && trust !== "" && appFeature.trusts.includes(trust)) {
              features.push(appFeature.name);
            }
          }
        }
      }
    }

    // features.push('customTrustGuidelineSections');
    // features.push('customTrustMedSections');
    // features.splice(features.indexOf('customTrustGuidelineSections'), 1);
    // features.splice(features.indexOf('customTrustMedSections'), 1);
    // features.push('userEditableStaffGroup')
    // features.push('userEditableRegions')
    // features.push('notificationsPage')

    return features;
  }

  async logout(allAccounts: boolean) {
    try {
      await AuthenticationController.clearUserData();
      this.clearPatientAge();

      if (allAccounts) {
        for (
          let rememberedUserIndex = 0;
          rememberedUserIndex < this.state.rememberedUsers.length;
          rememberedUserIndex++
        ) {
          let rememberedUser = this.state.rememberedUsers[rememberedUserIndex];
          await AuthenticationController.removeRememberedUser(rememberedUser);
        }
      }

      if (this.state.user) {
        if (this.state.user.isSSO) {
          try {
            OAuth2Client.logout({});
          } catch (error) {
            console.log(error);
          }
        }

        await AuthenticationController.removeRememberedUser(this.state.user);
      }

      await this.getRememberedUsers();

      this.setState({ finishedDownloadingAppData: false });

      this.userUpdated(null, false);

      this.showAccountModal(false);

      if ((isPlatform("ios") || isPlatform("android")) && !isPlatform("mobileweb")) {
        this.updatePushNotificationTopics();
      }

      RemoteDataController.logEvent("logout", {});
    } catch (error) {}
  }

  showTabBar(shouldShow: boolean) {
    this.setState({ tabBarVisible: shouldShow });
  }

  showStatusBar(shouldShow: boolean, backgroundColor?: string) {
    if (isPlatform("ios") || isPlatform("android")) {
      if (shouldShow) {
        // StatusBar.setStyle({ style: Style.Light }).catch((error) => { });
        if (backgroundColor) {
          StatusBar.setBackgroundColor({ color: backgroundColor }).catch((error) => {});
        } else {
          // StatusBar.setBackgroundColor({ color: "" }).catch((error) => { });
        }
        StatusBar.show().catch((error) => {});
      }
    }
  }

  async finishOnboarding() {
    DataController.saveFinishedOnboarding(true);
    this.setState({ showOnboarding: false });
  }

  async cfrDisclaimerDismissed() {
    DataController.saveCFRDisclaimerDismissed(true);
    this.setState({ cfrDisclaimerModalOpen: false });
  }

  async saveBookmark(
    GLID: string,
    algorithmID: IBookmark["algorithmID"],
    clinicalNoticeID: IBookmark["clinicalNoticeID"],
    pathwayID: IBookmark["pathwayID"],
    type: IBookmark["type"]
  ) {
    let wasBookmarked = false;

    if (GLID != null && GLID !== "") {
      if (type === "guideline") {
        wasBookmarked = await DataController.saveBookmark(GLID, null, null, null, "guideline");
      } else if (type === "algorithm") {
        wasBookmarked = await DataController.saveBookmark(GLID, algorithmID, null, null, "algorithm");
      } else if (type === "essentials") {
        wasBookmarked = await DataController.saveBookmark(GLID, null, null, null, "essentials");
      }
    } else if (type === "clinical notice") {
      if (clinicalNoticeID != null) {
        wasBookmarked = await DataController.saveBookmark("", null, clinicalNoticeID, null, "clinical notice");
      }
    } else if (type === "pathway") {
      if (pathwayID != null) {
        wasBookmarked = await DataController.saveBookmark("", null, null, pathwayID, "pathway");
      }
    }

    let bookmarks = await DataController.getAllBookmarks();
    await this.setStateAsync({ bookmarks });

    // update server app data with latest bookmarks
    this.uploadAppData();

    if (wasBookmarked) {
      RemoteDataController.logEvent("bookmarked_item", {
        type: type,
        glid: this.getGuidelineTitleForLogging(GLID),
        algorithmID: algorithmID,
        clinicalNoticeID: clinicalNoticeID,
        pathwayID: pathwayID,
      });
    }
  }

  async saveRecentlyViewed(
    GLID: string,
    algorithmID: IRecentlyViewed["algorithmID"],
    clinicalNoticeID: IRecentlyViewed["clinicalNoticeID"],
    pathwayID: IRecentlyViewed["pathwayID"],
    type: IRecentlyViewed["type"]
  ) {
    if (
      (GLID != null && GLID !== "") ||
      (type === "clinical notice" && clinicalNoticeID != null) ||
      (type === "pathway" && pathwayID != null)
    ) {
      await DataController.saveRecentlyViewed(GLID, algorithmID, clinicalNoticeID, pathwayID, type);

      let recentlyViewed = await DataController.getRecentlyViewed();
      await this.setStateAsync({ recentlyViewed });

      // update server app data with latest bookmarks
      this.uploadAppData();
    }
  }

  async syncAppData() {
    // send any data requests which haven't been succesfully sent yet to server
    // await RemoteDataController.sendRemoteQueue();

    // download user info so have the latest app data
    // await this.downloadAndUpdateUserInfo();

    // get app data from current subscription
    if (this.state.user) {
      let currentSubscription = this.getCurrentSubscription();

      if (currentSubscription != null) {
        if (currentSubscription.appData != null) {
          if (currentSubscription.appData.bookmarks) {
            DataController.saveAllBookmarks(currentSubscription.appData.bookmarks);
            // alert('sync app data bookmarks: ' + currentSubscription.appData.bookmarks.length);
            await this.setStateAsync({ bookmarks: currentSubscription.appData.bookmarks });
          }

          if (currentSubscription.appData.recentlyViewed) {
            DataController.saveAllRecentlyViewed(currentSubscription.appData.recentlyViewed);
            await this.setStateAsync({ recentlyViewed: currentSubscription.appData.recentlyViewed });
          }
        } else {
          this.setStateAsync({ finishedDownloadingAppData: true });

          // no app data for user so upload it
          this.uploadAppData();
        }
      }

      this.setStateAsync({ finishedDownloadingAppData: true });

      try {
        RemoteDataController.setUserProperty("bookmarkCount", "" + this.state.bookmarks.length);
      } catch (error) {
        console.log(error);
      }
    }
  }

  async uploadAppData() {
    if (this.state.user != null) {
      let currentSubscription = this.getCurrentSubscription();
      if (currentSubscription != null && this.state.finishedDownloadingAppData) {
        let pushNotificationTopics: string[] = [];
        if (currentSubscription.appData && currentSubscription.appData.pushNotificationTopics) {
          pushNotificationTopics = currentSubscription.appData.pushNotificationTopics;
        }
        RemoteDataController.uploadAppData(
          {
            updated: Date.now(),
            bookmarks: this.state.bookmarks,
            recentlyViewed: this.state.recentlyViewed,
            pushNotificationTopics: pushNotificationTopics,
          },
          currentSubscription.subscriberID,
          this.state.user
        );
      }
    }
  }

  async updateStaffGroups(staffGroups: string) {
    let currentSubscription = this.getCurrentSubscription();
    if (currentSubscription && this.state.user) {
      await RemoteDataController.updateStaffGroups(staffGroups, currentSubscription.subscriberID, this.state.user);
      RemoteDataController.logEvent("staff_group_changed", { trust: this.state.user.trust });
    }
    await this.downloadAndUpdateUserInfo();

    this.loadLocalData(false);
  }

  async updateRegions(regions: string) {
    let currentSubscription = this.getCurrentSubscription();
    if (currentSubscription && this.state.user) {
      await RemoteDataController.updateRegions(regions, currentSubscription.subscriberID, this.state.user);
    }
    await this.downloadAndUpdateUserInfo();
  }

  async updatePatientAge(patientAge: IPatientAge, from: string) {
    DataController.savePatientAge(patientAge);
    this.setState({ patientAge });

    try {
      RemoteDataController.logEvent("patient_age_clicked", { value: patientAge.name, from: from });
    } catch (error) {
      console.log(error);
    }
  }

  clearPatientAge() {
    let defaultPatientAge = DataController.getAgesObjects()[0];
    DataController.savePatientAge(defaultPatientAge);
    this.setState({ patientAge: defaultPatientAge });
  }

  toggleTestMode() {
    var testMode = !this.state.testMode;

    this.setState({ testMode: testMode }, () => {
      DataController.saveTestMode(testMode);
      this.loadData();
    });
  }

  async getDebugMode() {
    let debugMode = await DataController.getDebugMode();
    if (debugMode) {
      document.getElementsByTagName("body")[0].classList.add("debugMode");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("debugMode");
    }
    this.setState({ debugMode: debugMode });
  }

  async toggleDebugMode() {
    try {
      var debugMode = !this.state.debugMode;
      await DataController.saveDebugMode(debugMode);
      this.getDebugMode();
    } catch (error) {
      console.log(error);
    }
  }

  navigateToGuideline(
    GLID: string,
    currentTab: string,
    history: any,
    params: { [key: string]: any } | null,
    from: string
  ) {
    // from used for analytics
    let guidelineSummary = this.state.guidelineSummaries.find((guidelineSummary) => guidelineSummary.GLID === GLID);

    let passedParams = params;
    if (passedParams == null) {
      passedParams = { page: "Guideline" };
    } else {
      passedParams.page = "Guideline";
    }

    if (GLID.includes("-") && GLID.indexOf("-") !== 0) {
      // GLID is for a guideline
      this.navigateToAlgorithm(GLID, currentTab, history, from);
      return;
    }

    if (guidelineSummary) {
      if (DataController.isPageForAge(GLID)) {
        history.push(`/pageforage/${GLID}`, passedParams);
      } else if (DataController.isDrug(guidelineSummary)) {
        history.push(`/meds/${GLID}`, passedParams);
      } else {
        history.push(`/guidelines/${GLID}`, passedParams);
      }
    } else {
      if (this.state.messageBarText !== "") {
        alert("This guideline can't be opened. It might still be downloading. Please try again shortly.");
      } else {
        alert("This guideline can't be opened.");
      }
    }

    let isDrug = false;
    if (guidelineSummary) {
      isDrug = DataController.isDrug(guidelineSummary);
    }

    if (isDrug) {
      RemoteDataController.logEvent("med_clicked", { glid: this.getGuidelineTitleForLogging(GLID), from: from });
    } else {
      RemoteDataController.logEvent("guideline_clicked", { glid: this.getGuidelineTitleForLogging(GLID), from: from });
    }
  }

  navigateToAlgorithm(algorithmID: string, currentTab: string, history: any, from: string) {
    history.push(`/algorithms/${algorithmID}`, { page: "Algorithm" });
    RemoteDataController.logEvent("algorithm_clicked", { algorithmID: algorithmID, from: from });
  }

  navigateToClinicalNotice(
    clinicalNoticeID: IClinicalNotice["ID"],
    currentTab: string,
    history: any,
    params: any,
    from: string
  ) {
    let passedParams = params;
    if (passedParams == null) {
      passedParams = { page: "Clinical Notice" };
    } else {
      passedParams.page = "Clinical Notice";
    }

    // check if clinical notice is just a link to a pdf. If so open the PDF, other navigate to it
    let clinicalNoticeIsPDFOnly = false;
    let clinicalNotice = this.state.clinicalNotices.find((cn) => cn.ID === clinicalNoticeID);
    if (clinicalNotice != null) {
      if (clinicalNotice.content_container.includes("</style><p> Related PDF")) {
        clinicalNoticeIsPDFOnly = true;
      }
    }

    if (clinicalNoticeIsPDFOnly) {
      if (clinicalNotice != null) {
        let pdfUrlStartIndex = clinicalNotice.content_container.indexOf('Related PDF: <a href="') + 22;
        let pdfUrlEndIndex = clinicalNotice.content_container.indexOf(".pdf") + 4;
        if (pdfUrlStartIndex > 21 && pdfUrlEndIndex > 3) {
          let pdfUrl = clinicalNotice.content_container.substr(pdfUrlStartIndex, pdfUrlEndIndex - pdfUrlStartIndex);
          if (isPlatform("android")) {
            window.open(pdfUrl, "_system", "noreferrer");
          } else {
            Browser.open({ url: pdfUrl });
          }
        } else {
          alert("Clinical notice couldn't be opened. Please check your internet connection and try again.");
        }
      }
    } else {
      history.push(`/dashboard/clinicalnotices/${clinicalNoticeID}`, passedParams);
    }

    RemoteDataController.logEvent("clinical_notice_clicked", { clinicalNoticeID: clinicalNoticeID + "", from: from });
  }

  navigateToPathway(
    pathway: IPathway | IPathwayBypassNumber | IPathwayWhatGoesWhere,
    currentTab: string,
    history: any,
    from: string
  ) {
    history.push(`/pathways/${pathway.id}`, { page: "Pathway" });

    try {
      if (DataController.isPathway(pathway)) {
        RemoteDataController.logEvent("pathway_clicked", {
          name: pathway.fields["Pathway name"],
          pathwayID: pathway.id,
          from: from,
        });
      } else if (DataController.isBypassNumber(pathway)) {
        RemoteDataController.logEvent("pathway_clicked", {
          name: pathway.fields["Pathway category"],
          pathwayID: pathway.id,
          from: from,
        });
      } else if (DataController.isWhatGoesWhere(pathway)) {
        RemoteDataController.logEvent("pathway_clicked", {
          name: pathway.fields.Name,
          pathwayID: pathway.id,
          from: from,
        });
      }
    } catch (error) {}
  }

  navigateToEssentialSection(essentialSection: IEssentialSection, currentTab: string, history: any, from: string) {
    history.push(`/essentials/${essentialSection.id}`, { page: "Essentials" });

    try {
      RemoteDataController.logEvent("essentials_section_clicked", { name: essentialSection.Name, from: from });
    } catch (error) {}
  }

  navigateToTrustPinsList(trustPin: ITrustPin, currentTab: string, history: any) {
    let trustPinName = encodeURIComponent(trustPin.name);
    history.push(`/dashboard/pin/${trustPinName}`, { page: "Trust Pin List" });
  }

  async takeParaPassQuiz(name: string) {
    if (this.state.user != null && this.state.user.uid) {
      if (isPlatform("android")) {
        let url = "cpgcpd://quiz/" + name + "/uid/" + this.state.user.uid;

        var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

        if (canOpenApp) {
          var appOpenedState = await AppLauncher.openUrl({ url: url });

          if (!appOpenedState.completed) {
            // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
            window.open(
              "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
              "_system",
              "noreferrer"
            );
          }
        } else {
          // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
          window.open(
            "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
            "_system",
            "noreferrer"
          );
        }
      } else if (isPlatform("ios")) {
        let url = "cpgcpd://quiz/" + name + "/uid/" + this.state.user.uid;

        var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

        if (canOpenApp) {
          var appOpenedState = await AppLauncher.openUrl({ url: url });

          if (!appOpenedState.completed) {
            Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
          }
        } else {
          Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
        }
      } else {
        let url = "https://parapassweb.co.uk/?quiz=" + name + "&uid=" + this.state.user.uid;
        window.open(url, "_system", "noreferrer");
      }
    }
  }

  async takeParaPassPGDQuiz(GLID: string) {
    if (this.state.user != null && this.state.user.uid) {
      if (isPlatform("android")) {
        let url = "cpgcpd://glid/" + GLID + "/uid/" + this.state.user.uid;

        var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

        if (canOpenApp) {
          var appOpenedState = await AppLauncher.openUrl({ url: url });

          if (!appOpenedState.completed) {
            // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
            window.open(
              "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
              "_system",
              "noreferrer"
            );
          }
        } else {
          // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
          window.open(
            "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
            "_system",
            "noreferrer"
          );
        }
      } else if (isPlatform("ios")) {
        let url = "cpgcpd://glid/" + GLID + "/uid/" + this.state.user.uid;

        var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

        if (canOpenApp) {
          var appOpenedState = await AppLauncher.openUrl({ url: url });

          if (!appOpenedState.completed) {
            Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
          }
        } else {
          Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
        }
      } else {
        let url = "https://parapassweb.co.uk/?glid=" + GLID + "&uid=" + this.state.user.uid;
        window.open(url, "_system", "noreferrer");
      }
    }
  }

  async openParaPass() {
    if (isPlatform("android")) {
      let url = "co.uk.classprofessional.cpdquiz";

      var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

      if (canOpenApp) {
        var appOpenedState = await AppLauncher.openUrl({ url: url });

        if (!appOpenedState.completed) {
          // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
          window.open(
            "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
            "_system",
            "noreferrer"
          );
        }
      } else {
        // Browser.open({url: 'https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz'});
        window.open(
          "https://play.google.com/store/apps/details?id=co.uk.classprofessional.cpdquiz",
          "_system",
          "noreferrer"
        );
      }
    } else if (isPlatform("ios")) {
      let url = "cpgcpd://open";

      var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

      if (canOpenApp) {
        var appOpenedState = await AppLauncher.openUrl({ url: url });

        if (!appOpenedState.completed) {
          Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
        }
      } else {
        Browser.open({ url: "https://apps.apple.com/gb/app/parapass/id1220803129" });
      }
    } else {
      let url = "https://parapassweb.co.uk";
      window.open(url, "_system", "noreferrer");
    }
  }

  async openParaFolio() {
    if (isPlatform("android")) {
      let url = "uk.co.classprofessional.parafolio";

      var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

      if (canOpenApp) {
        var appOpenedState = await AppLauncher.openUrl({ url: url });

        if (!appOpenedState.completed) {
          window.open(
            "https://play.google.com/store/apps/details?id=uk.co.classprofessional.parafolio",
            "_system",
            "noreferrer"
          );
        }
      } else {
        window.open(
          "https://play.google.com/store/apps/details?id=uk.co.classprofessional.parafolio",
          "_system",
          "noreferrer"
        );
      }
    } else if (isPlatform("ios")) {
      let url = "parafolio://open";

      var canOpenApp = await AppLauncher.canOpenUrl({ url: url });

      if (canOpenApp) {
        var appOpenedState = await AppLauncher.openUrl({ url: url });

        if (!appOpenedState.completed) {
          Browser.open({ url: "https://apps.apple.com/gb/app/parafolio/id6449023723" });
        }
      } else {
        Browser.open({ url: "https://apps.apple.com/gb/app/parafolio/id6449023723" });
      }
    } else {
      let url = "https://paraportfolio.co.uk";
      window.open(url, "_system", "noreferrer");
    }
  }

  async processGuidelineText() {
    // if ((isPlatform('desktop') || isPlatform('mobileweb')) && process.env.NODE_ENV === 'production') {
    //   return; // todo - currently massively slows performance down on production web as has to download each guideline for it's text
    // }

    let guidelinesText: { GLID: string; text: string }[] = [];

    let trust = "";
    if (this.state.user) {
      trust = this.state.user.trust;
    }

    let guidelines = await DataController.getGuidelines(trust, this.props.app);

    for (let guidelineIndex = 0; guidelineIndex < guidelines.length; guidelineIndex++) {
      let guideline = guidelines[guidelineIndex];

      if (guidelineIndex % 10 === 0) {
        await DataController.waitForMilliseconds(10);
      }

      let guidelineHtml = "";
      let guidelineText = "";

      if (guideline.sections != null) {
        for (
          let guidelineSectionIndex = 0;
          guidelineSectionIndex < guideline.sections.length;
          guidelineSectionIndex++
        ) {
          let guidelineSection = guideline.sections[guidelineSectionIndex];
          guidelineHtml += guidelineSection.sectionHTML + " ";

          if (DataController.isPageForAge(guideline.GLID)) {
            if (guidelineSection.TableAndBoxes) {
              for (let tableAndBox of guidelineSection.TableAndBoxes) {
                if (tableAndBox.rowColData) {
                  for (let rowColData of tableAndBox.rowColData) {
                    if (rowColData.columns) {
                      for (let column of rowColData.columns) {
                        guidelineHtml += " " + column.text;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else if (guideline.html != null) {
        guidelineHtml = guideline.html;
      }

      if (guidelineHtml !== "") {
        guidelineText = stripHtml(guidelineHtml, { stripTogetherWithTheirContents: ["a"] }).result;
      }

      guidelineText = guidelineText.replace(
        "Showing for age: All AllAdult18+16 to 1812 to AdultChild12 to 16 years11 years10 years9 years8 years7 years6 years5 years4 years3 years2 years18 monthsInfant12 months9 months6 months3 months1 monthBirth",
        ""
      );

      guidelinesText.push({ GLID: guideline.GLID, text: guidelineText });
    }

    this.setState({ guidelinesText, guidelineTextFinishedLoading: true });
  }

  getGuidelineText(GLID: string) {
    let guidelineText = this.state.guidelinesText.find((guidelineText) => guidelineText.GLID === GLID);
    if (guidelineText != null) {
      return guidelineText.text;
    } else {
      return "";
    }
  }

  async processClinicalNoticeText() {
    let clinicalNoticesText: { CNID: number; text: string }[] = [];

    let clinicalNotices = await DataController.getClinicalNotices(this.state.trust, this.state.testMode);

    for (let clinicalNoticeIndex = 0; clinicalNoticeIndex < clinicalNotices.length; clinicalNoticeIndex++) {
      let clinicalNotice = clinicalNotices[clinicalNoticeIndex];

      if (clinicalNoticeIndex % 10 === 0) {
        await DataController.waitForMilliseconds(10);
      }

      let clinicalNoticeText = stripHtml(clinicalNotice.content_container, {
        stripTogetherWithTheirContents: ["a", "style"],
      }).result;

      clinicalNoticeText = clinicalNoticeText.replace("Related PDF:", "");

      clinicalNoticesText.push({ CNID: clinicalNotice.ID, text: clinicalNoticeText });
    }

    this.setState({ clinicalNoticesText });
  }

  getClinicalNoticeText(CNID: number) {
    let clinicalNoticeText = this.state.clinicalNoticesText.find(
      (clinicalNoticeText) => clinicalNoticeText.CNID === CNID
    );
    if (clinicalNoticeText != null) {
      return clinicalNoticeText.text;
    } else {
      return "";
    }
  }

  async processEssentialsText() {
    let essentialsText: { essentialSectionID: string; text: string }[] = [];

    for (
      let essentialSectionIndex = 0;
      essentialSectionIndex < this.state.essentialSections.length;
      essentialSectionIndex++
    ) {
      let essentialSection = this.state.essentialSections[essentialSectionIndex];

      if (essentialSectionIndex % 10 === 0) {
        await DataController.waitForMilliseconds(10);
      }

      let essentialSectionHtml = "";
      let essentialSectionText = "";

      if (essentialSection.HtmlData != null) {
        essentialSectionHtml = essentialSection.HtmlData;
      }

      if (essentialSectionHtml !== "") {
        essentialSectionText = stripHtml(essentialSectionHtml, { stripTogetherWithTheirContents: ["a"] }).result;
      }

      essentialsText.push({ essentialSectionID: essentialSection.id, text: essentialSectionText });
    }

    this.setState({ essentialsText });
  }

  getEssentialsText(essentialSectionID: string) {
    let essentialSectionText = this.state.essentialsText.find(
      (essentialSectionText) => essentialSectionText.essentialSectionID === essentialSectionID
    );
    if (essentialSectionText != null) {
      return essentialSectionText.text;
    } else {
      return "";
    }
  }

  isGuidelineUpdated(guidelineSummary: IGuidelineSummary) {
    let lastOpenedVersion = this.state.lastOpenedGuidelineVersions[guidelineSummary.GLID];
    let updated = lastOpenedVersion ? lastOpenedVersion.updated : true;

    for (
      let significantChangeIndex = 0;
      significantChangeIndex < this.state.significantChanges.length;
      significantChangeIndex++
    ) {
      let significantChange = this.state.significantChanges[significantChangeIndex];

      if (significantChange.GLID === guidelineSummary.GLID) {
        let significantChangeAck = this.state.significantChangeAcks.find(
          (significantChangeAck) => significantChangeAck.cnid === significantChange.id
        );

        if (significantChangeAck == null) {
          return true;
        }
      }
    }

    return false;
  }

  updateGuidelineLastOpenedVersion(guidelineSummary: IGuidelineSummary) {
    try {
      let lastOpenedGuidelineVersions = this.state.lastOpenedGuidelineVersions;

      lastOpenedGuidelineVersions[guidelineSummary.GLID] = {
        publ_major_version_no: guidelineSummary.publ_major_version_no,
        publ_minor_version_no: guidelineSummary.publ_minor_version_no,
        updated: false,
      };

      this.setState({ lastOpenedGuidelineVersions });
      DataController.saveLastOpenedGuidelineVersions(lastOpenedGuidelineVersions);
    } catch (error) {
      console.log(error);
    }
  }

  getGuidelineTitleForLogging(GLID: string | null | undefined) {
    if (GLID != null) {
      let guidelineSummary = this.state.guidelineSummaries.find((guidelineSummary) => guidelineSummary.GLID === GLID);
      if (guidelineSummary != null && guidelineSummary.Title != null) {
        return GLID + " - " + guidelineSummary.Title;
      }
    }
    return GLID + "";
  }

  async acknowledgeClinicalNotice(clinicalNotice: IClinicalNotice) {
    if (this.state.user != null && this.state.user.uid) {
      // create a new ack
      var now = new Date();
      var accessTime = now.toISOString();
      let newCNAck: IClinicalNoticeAck = {
        contactID: this.state.user.uid,
        cnid: clinicalNotice.ID,
        title: clinicalNotice.Title,
        timestamp: accessTime,
        trust: this.state.user.trust,
      };

      // save ack locally
      let updatedCNAcks = await DataController.saveClinicalNoticeAck(newCNAck);

      // update state with the new ack
      await this.setStateAsync({ clinicalNoticeAcks: updatedCNAcks });

      // send the new ack to server
      await RemoteDataController.acknowledgeClinicalNotice(newCNAck, this.props.app);
      await DataController.logLocalUsage(null, null, clinicalNotice, newCNAck, null, null, this.state.user.email);
    }
  }

  async acknowledgeSignificantChange(significantChange: ISignificantChange, from: string) {
    if (this.state.user != null && this.state.user.uid) {
      // create a new ack
      var now = new Date();
      var accessTime = now.toISOString();
      let newSignificantChangeAck: ISignificantChangeAck = {
        cnid: significantChange.id,
        trust: this.state.user.trust,
        timestamp: accessTime,
        contactID: this.state.user.uid,
        title: significantChange.title,
      };

      // save ack locally
      let updatedSignificantChangeAcks = await DataController.saveSignificantChangeAck(newSignificantChangeAck);

      // update state with the new ack
      await this.setStateAsync({ significantChangeAcks: updatedSignificantChangeAcks });

      // send the new ack to server
      await RemoteDataController.acknowledgeSignificantChange(newSignificantChangeAck, this.state.user);
      await DataController.logLocalUsage(
        null,
        null,
        null,
        null,
        significantChange,
        newSignificantChangeAck,
        this.state.user.email
      );

      RemoteDataController.logEvent("significant_change_acknowledged", {
        glid: this.getGuidelineTitleForLogging(significantChange.GLID),
        name: significantChange.title,
        from: from,
      });
    }
  }

  async acknowledgePGD(guidelineSummary: IGuidelineSummary) {
    let didAcknowledge = false;

    if (this.state.user != null) {
      // send acknowledgement request to server
      didAcknowledge = await RemoteDataController.acknowledgePGD(guidelineSummary, this.state.user);

      if (didAcknowledge) {
        // download the updated acknowledgement
        let updatedPGDAcks = await RemoteDataController.downloadSinglePGDAck(guidelineSummary.GLID, this.state.user);

        // update state with the latest acks
        if (updatedPGDAcks != null && updatedPGDAcks.length !== 0) {
          await this.setStateAsync({ pgdAcks: updatedPGDAcks });
        }
      }
    }

    return didAcknowledge;
  }

  async acknowledgeGuideline(guidelineSummary: IGuidelineSummary) {
    let didAcknowledge = false;

    if (this.state.user != null) {
      // send acknowledgement request to server
      didAcknowledge = await RemoteDataController.acknowledgeGuideline(
        guidelineSummary,
        this.state.user,
        this.props.app
      );

      if (didAcknowledge) {
        // download the updated acknowledgements
        await RemoteDataController.downloadGLAcks(this.state.user, this.props.app);
        let updatedGLAcks = await DataController.getGLAcks();

        // update state with the latest acks
        if (updatedGLAcks != null && updatedGLAcks.length !== 0) {
          await this.setStateAsync({ glAcks: updatedGLAcks });
        }
      }
    }

    return didAcknowledge;
  }

  async checkPGDRemoteStatus(guidelineSummary: IGuidelineSummary) {
    if (this.state.user != null) {
      // download the pgd acknowledgement
      let updatedPGDAcks = await RemoteDataController.downloadSinglePGDAck(guidelineSummary.GLID, this.state.user);

      let updatedPGDAcksAreDifferent = !_.isEqual(this.state.pgdAcks, updatedPGDAcks);

      // update state with the latest acks
      if (updatedPGDAcks != null && updatedPGDAcks.length !== 0 && updatedPGDAcksAreDifferent) {
        await this.setStateAsync({ pgdAcks: updatedPGDAcks });
      }
    }
  }

  showAccountDeletionAlert(shouldShow: boolean) {
    this.setState({ showAccountDeletionAlert: shouldShow });
  }

  async requestAccountDeletion() {
    this.showAccountModal(false);
    this.showAccountDeletionAlert(true);
  }

  async sendAccountDeletionRequest() {
    try {
      if (this.state.user) {
        let success = await AuthenticationController.requestAccountDeletion(this.state.user, this.props.app);
        if (success === true) {
          this.logout(false);
          alert(
            "Your account has been requested to be deleted. You'll be notified when your account has successfully been deleted."
          );
        } else {
          alert("Request failed to send. Please try again shortly.");
        }
      } else {
        alert("Couldn't delete user.");
      }
    } catch (error) {
      alert("Request failed to send. Please try again shortly.");
    }

    this.showAccountDeletionAlert(false);
  }

  configurePushNotifications() {
    PushNotifications.checkPermissions().then((res) => {
      if (res.receive !== "granted") {
        PushNotifications.requestPermissions().then((res) => {
          if (res.receive === "denied") {
            console.log("Push Notification permission denied");
          } else {
            console.log("Push Notification permission granted");
            this.registerPushNotifcations();
          }
        });
      } else {
        this.registerPushNotifcations();
      }
      RemoteDataController.setUserProperty("notificationsEnabled", res.receive === "granted" ? "true" : "false");
    });
  }

  async registerPushNotifcations() {
    // Register with Apple / Google to receive push via APNS/FCM
    await PushNotifications.register();

    this.updatePushNotificationTopics();

    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", async (token: Token) => {
      console.log("Push notification registration success. Token: " + token.value);
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error: any) => {
      console.log("Error on push notifcation registration: " + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener("pushNotificationReceived", (notification: PushNotificationSchema) => {
      console.log("Push notification received");
      this.downloadLatestNotifications();
      alert(notification.title + ". " + notification.body);
    });

    // Method called when tapping on a notification
    PushNotifications.addListener("pushNotificationActionPerformed", (notification: ActionPerformed) => {
      console.log("Push notification received");

      if (notification && notification.notification && notification.notification.data) {
        let locationHref = "localhost:8100";
        let firstArgFound = false;

        for (const [key, value] of Object.entries(notification.notification.data)) {
          console.log(`${key}: ${value}`);
          locationHref += firstArgFound ? "&" : "?";
          locationHref += key + "=" + value;
          firstArgFound = true;
        }

        if (this.state.user == null) {
          // delay handling app open as won't work until there is a user
          this.setState({ pushNotificationActionUrl: locationHref });
        } else {
          this.handleAppOpenURL(locationHref);
        }
      }
    });
  }

  async downloadLatestNotifications() {
    try {
      if (this.state.user) {
        await RemoteDataController.downloadNotifications(this.state.user, this.props.app);
        await this.updateNotificationsCount();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async updateNotificationsCount() {
    try {
      if (this.state.user == null) {
        return;
      }

      let trust = this.state.user ? this.state.user.trust : "";
      const features: string[] = await this.getFilteredAppFeatures(this.state.testMode, trust);
      if (features.includes("notificationsPage") === false) {
        return;
      }

      let notifications = await DataController.getNotifications();

      // check how many notifcations are new (more recent than last read time)
      let notificationCount = 0;
      let lastReadDate = await DataController.getNotificationsLastReadTime();

      // remove notifications that don't belong to the user
      for (let notificationIndex = notifications.length - 1; notificationIndex >= 0; notificationIndex--) {
        let notification = notifications[notificationIndex];

        let notificationIsForUser = true;

        if (notification.isSent !== true) {
          notificationIsForUser = false;
        }

        if (notification.topics != null && this.state.user.pushNotificationTopics != null) {
          let sharedTopics = _.intersection(notification.topics, this.state.user.pushNotificationTopics);
          if (sharedTopics.length === 0) {
            notificationIsForUser = false;
          }
        }

        if (notificationIsForUser === false) {
          notifications.splice(notificationIndex, 1);
        }
      }

      for (let notificationIndex = 0; notificationIndex < notifications.length; notificationIndex++) {
        let notification = notifications[notificationIndex];

        if (notification.date != null && notification.date > lastReadDate) {
          notificationCount++;
        }
      }

      this.setState({ notifications, notificationCount: notificationCount });
    } catch (error) {
      console.log(error);
    }
  }

  markNotificationsAsRead() {
    try {
      let now = new Date().getTime();
      DataController.saveNotificationsLastReadTime(now);

      this.setState({ notificationCount: 0 });
      if ((isPlatform("ios") || isPlatform("android")) && isPlatform("mobileweb") === false) {
        PushNotifications.removeAllDeliveredNotifications();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async notificationClicked(notification: INotification) {
    let locationHref = "localhost:8100";
    let firstArgFound = false;

    if (notification.data) {
      for (const [key, value] of Object.entries(notification.data)) {
        console.log(`${key}: ${value}`);
        locationHref += firstArgFound ? "&" : "?";
        locationHref += key + "=" + value;
        firstArgFound = true;
      }

      if (this.state.user != null) {
        this.handleAppOpenURL(locationHref);
      }
    }
  }

  async updatePushNotificationTopics() {
    let topicsToSubscribeTo = [];

    // add custom topics for each user that are stored on server
    if (this.state.user && this.state.user.pushNotificationTopics) {
      for (let topic of this.state.user.pushNotificationTopics) {
        topicsToSubscribeTo.push(topic);
      }
    }

    // if topic is in subscribedPushNotificationTopics but isn't part of topicsToSubscribeTo - then it should be unsubscribed from
    let topicsToUnsubscribeFrom: string[] = [];
    let subscribedPushNotificationTopics = await DataController.getSubscribedPushNotificationTopics();

    if (subscribedPushNotificationTopics.length === 0) {
      // haven't saved push notification topics before - could be subscribed accidently to wrong topics - so unsubscribe from all - this should only happen once
      let oldTopicsToUnsubscribeFrom = DataController.getTrusts(this.props.app);
      for (let topic of oldTopicsToUnsubscribeFrom) {
        if (topicsToSubscribeTo.includes(topic) === false) {
          topicsToUnsubscribeFrom.push(topic);
        }
      }
    }

    for (let subscribedTopic of subscribedPushNotificationTopics) {
      if (topicsToSubscribeTo.includes(subscribedTopic) === false) {
        topicsToUnsubscribeFrom.push(subscribedTopic);
      }
    }

    // subscribe to topics (doesn't matter if already subscribed)
    for (let topic of topicsToSubscribeTo) {
      try {
        let message = await FCM.subscribeTo({ topic: topic });
        console.log(`subscribed to ${topic}`);
        if (subscribedPushNotificationTopics.includes(topic) === false) {
          subscribedPushNotificationTopics.push(topic);
        }
      } catch (error) {
        console.log(error);
      }
    }

    // unsubscribe from topics that user is no longer part of
    for (let topic of topicsToUnsubscribeFrom) {
      try {
        let message = await FCM.unsubscribeFrom({ topic: topic });
        console.log(`unsubscribed from ${topic}`);
        let topicIndex = subscribedPushNotificationTopics.indexOf(topic);
        if (topicIndex > -1) {
          // only splice array when item is found
          subscribedPushNotificationTopics.splice(topicIndex, 1);
        }
      } catch (error) {
        console.log(error);
      }
    }

    await DataController.saveSubscribedPushNotificationTopics(subscribedPushNotificationTopics);
  }

  async getExternalCSS() {
    try {
      let externalCSS = await DataController.getExternalCSS();
      const styleTag = document.createElement("style");
      styleTag.textContent = externalCSS;
      document.head.appendChild(styleTag);
    } catch (error) {
      console.log("error loading external css: " + error);
    }
  }

  async getFontSize() {
    let size = await DataController.getFontSize();
    this.setState({ fontSizeChange: size });

    document.documentElement.style.setProperty("--font-size-change", size + "px");
    this.updateBulletPositions();

    try {
      let fontSizePercentage = 100 + size * 10;
      RemoteDataController.setUserProperty("fontSize", "" + fontSizePercentage);
    } catch (error) {
      console.log(error);
    }
  }

  increaseFontSize() {
    if (this.state.fontSizeChange < 10) {
      let fontSizeChange = this.state.fontSizeChange + 1;
      DataController.saveFontSize(fontSizeChange);

      this.setState({
        fontSizeChange: fontSizeChange,
      });

      document.documentElement.style.setProperty("--font-size-change", fontSizeChange + "px");
      this.updateBulletPositions();
    }
  }

  decreaseFontSize() {
    if (this.state.fontSizeChange > -5) {
      let fontSizeChange = this.state.fontSizeChange - 1;
      DataController.saveFontSize(fontSizeChange);

      this.setState({
        fontSizeChange: fontSizeChange,
      });

      document.documentElement.style.setProperty("--font-size-change", fontSizeChange + "px");
      this.updateBulletPositions();
    }
  }

  resetFontSize() {
    if (this.state.fontSizeChange !== 0) {
      DataController.saveFontSize(0);

      this.setState({
        fontSizeChange: 0,
      });

      document.documentElement.style.setProperty("--font-size-change", "0px");
      this.updateBulletPositions();
    }
  }

  setFontSize(fontSizeChange: number) {
    DataController.saveFontSize(fontSizeChange);

    this.setState({
      fontSizeChange: fontSizeChange,
    });

    document.documentElement.style.setProperty("--font-size-change", fontSizeChange + "px");
    this.updateBulletPositions();
  }

  async getLineHeight() {
    let lineHeight = await DataController.getLineHeight();
    this.setState({ lineHeightChange: lineHeight });

    document.documentElement.style.setProperty("--line-height", lineHeight + "px");
    this.updateBulletPositions();

    try {
      RemoteDataController.setUserProperty("lineHeight", "" + lineHeight);
    } catch (error) {
      console.log(error);
    }
  }

  increaseLineHeight() {
    if (this.state.lineHeightChange < 4) {
      let lineHeightChange = this.state.lineHeightChange + 0.5;
      DataController.saveLineHeight(lineHeightChange);

      this.setState({
        lineHeightChange: lineHeightChange,
      });

      document.documentElement.style.setProperty("--line-height", lineHeightChange + "px");
      this.updateBulletPositions();
    }
  }

  decreaseLineHeight() {
    if (this.state.lineHeightChange > 1) {
      let lineHeightChange = this.state.lineHeightChange - 0.5;
      DataController.saveLineHeight(lineHeightChange);

      this.setState({
        lineHeightChange: lineHeightChange,
      });

      document.documentElement.style.setProperty("--line-height", lineHeightChange + "px");
      this.updateBulletPositions();
    }
  }

  resetLineHeight() {
    if (this.state.lineHeightChange !== 0) {
      DataController.saveLineHeight(1.5);

      this.setState({
        lineHeightChange: 1.5,
      });

      document.documentElement.style.setProperty("--line-height", 1.5 + "px");
      this.updateBulletPositions();
    }
  }

  setLineHeight(lineHeight: number) {
    DataController.saveLineHeight(lineHeight);

    this.setState({
      lineHeightChange: lineHeight,
    });

    document.documentElement.style.setProperty("--line-height", lineHeight + "px");
    this.updateBulletPositions();
  }

  updateBulletPositions() {
    setTimeout(() => {
      document.documentElement.style.setProperty(
        "--bullet-position-y",
        -5 + 6 * (this.state.lineHeightChange * 1.5) + this.state.fontSizeChange + "px"
      );
    }, 10);
  }

  async getFontFamily() {
    let fontFamily = await DataController.getFontFamily();
    this.setSelectedFontFamily(fontFamily);

    try {
      RemoteDataController.setUserProperty("fontFamily", fontFamily);
    } catch (error) {
      console.log(error);
    }
  }

  setSelectedFontFamily(fontFamily: string) {
    document.documentElement.style.setProperty("--ion-font-family", fontFamily);
    DataController.saveFontFamily(fontFamily);
    this.setState({ selectedFontFamily: fontFamily });
  }

  async getShowTextToSpeech() {
    let shouldShow = await DataController.getShowTextToSpeech();
    this.setShowTextToSpeech(shouldShow);

    try {
      RemoteDataController.setUserProperty("showTextToSpeech", "" + shouldShow);
    } catch (error) {
      console.log(error);
    }
  }

  setShowTextToSpeech(shouldShow: boolean) {
    DataController.saveShowTextToSpeech(shouldShow);
    this.setState({ showTextToSpeech: shouldShow });
  }

  async getTextToSpeechSpeed() {
    let textToSpeechSpeed = await DataController.getTextToSpeechSpeed();
    this.setTextToSpeechSpeed(textToSpeechSpeed);

    try {
      RemoteDataController.setUserProperty("textToSpeechSpeed", "" + textToSpeechSpeed);
    } catch (error) {
      console.log(error);
    }
  }

  setTextToSpeechSpeed(value: number) {
    DataController.saveTextToSpeechSpeed(value);
    this.setState({ textToSpeechSpeed: value });
  }

  async getFontWeight() {
    let fontWeight = await DataController.getFontWeight();
    this.setFontWeight(fontWeight);

    try {
      RemoteDataController.setUserProperty("fontWeight", "" + fontWeight);
    } catch (error) {
      console.log(error);
    }
  }

  setFontWeight(fontWeight: string) {
    if (fontWeight !== "400") {
      document.documentElement.style.setProperty("--accessability-bold-text", fontWeight);
    } else {
      document.documentElement.style.setProperty("--accessability-bold-text", "initial");
    }

    DataController.saveFontWeight(fontWeight);
    this.setState({ fontWeight: fontWeight });
  }

  async getAccessabilityUnderlineLinks() {
    let shouldUse = await DataController.getAccessabilityUnderlineLinks();
    this.setAccessabilityUnderlineLinks(shouldUse);
  }

  setAccessabilityUnderlineLinks(shouldUse: boolean) {
    if (shouldUse) {
      document.documentElement.style.setProperty("--accessability-underline-links", "underline");
    } else {
      document.documentElement.style.setProperty("--accessability-underline-links", "initial");
    }

    DataController.saveAccessabilityUnderlineLinks(shouldUse);
    this.setState({ accessabilityUnderlineLinks: shouldUse });
  }

  async getHideParaPassLinks() {
    let isHidden = await DataController.getHideParaPassLinks();
    this.setHideParaPassLinks(isHidden);
  }

  setHideParaPassLinks(isHidden: boolean) {
    DataController.saveHideParaPassLinks(isHidden);
    this.setState({ hideParaPassLinks: isHidden });
  }

  async getABTestingVersion() {
    let abTestingVersion = await DataController.getABTestingVersion();
    this.setState({ abTestingVersion });

    try {
      RemoteDataController.setUserProperty("abTestingVersion", abTestingVersion);
    } catch (error) {
      console.log(error);
    }
  }

  setLowVisMode(shouldUse: boolean) {
    if (shouldUse) {
      this.setFontSize(5);
      this.setFontWeight("bold");
      this.setLineHeight(3);
    } else {
      this.resetFontSize();
      this.resetLineHeight();
      this.setFontWeight("400");
    }
  }

  async configureAppearance() {
    let savedAppearance = await DataController.getAppearance();
    await this.setStateAsync({ appearance: savedAppearance });

    this.checkDarkMode();

    // Listen for changes to the prefers-color-scheme media query
    const prefersDarkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    prefersDarkMediaQuery.addListener(async (e) => {
      this.checkDarkMode();
    });

    try {
      RemoteDataController.setUserProperty("appearance", savedAppearance);
    } catch (error) {
      console.log(error);
    }
  }

  checkDarkMode() {
    const prefersDarkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (this.state.appearance === "Auto") {
      // automatic mode - so set dark mode to whatever system dark mode is (using media query)
      let prefersDark = prefersDarkMediaQuery.matches;
      // change color scheme
      document.body.classList.toggle("dark", prefersDark);

      if (this.state.darkMode !== prefersDark) {
        this.setState({ darkMode: prefersDark });
      }
    } else {
      // not automatic so use whatever value user has saved
      // change color scheme
      let darkMode = this.state.appearance === "Dark";
      document.body.classList.toggle("dark", darkMode);
      if (darkMode !== this.state.darkMode) {
        this.setState({ darkMode: darkMode });
      }
    }
  }

  async setAppearance(value: IScreenProps["appearance"]) {
    DataController.saveAppearance(value);
    await this.setStateAsync({ appearance: value });
    this.checkDarkMode();
  }

  async getShowColorFilter() {
    let shouldShow = await DataController.getShowColorFilter();
    this.setShowColorFilter(shouldShow);

    try {
      RemoteDataController.setUserProperty("showColorFilter", "" + shouldShow);
    } catch (error) {
      console.log(error);
    }
  }

  setShowColorFilter(shouldShow: boolean) {
    DataController.saveShowColorFilter(shouldShow);
    this.setState({ showColorFilter: shouldShow });

    if (shouldShow) {
      this.getFilterColor();
    } else {
      document.documentElement.style.setProperty("--filter-color", `transparent`);
    }
  }

  async getFilterColor() {
    let filterColor = await DataController.getFilterColor();
    this.setState({ filterColor: filterColor });

    if (this.state.showColorFilter) {
      document.documentElement.style.setProperty(
        "--filter-color",
        `rgba(${filterColor.r}, ${filterColor.g}, ${filterColor.b}, ${filterColor.a})`
      );
    } else {
      document.documentElement.style.setProperty("--filter-color", `transparent`);
    }
  }

  setFilterColor(filterColor: IScreenProps["filterColor"]) {
    DataController.saveFilterColor(filterColor);

    this.setState({
      filterColor: filterColor,
    });

    document.documentElement.style.setProperty(
      "--filter-color",
      `rgba(${filterColor.r}, ${filterColor.g}, ${filterColor.b}, ${filterColor.a})`
    );
  }

  async getFreezeFirstDrugColumn() {
    let shouldFreeze = await DataController.getFreezeFirstDrugColumn();
    this.setFreezeFirstDrugColumn(shouldFreeze);

    try {
      RemoteDataController.setUserProperty("freezeFirstDrugColumn", "" + shouldFreeze);
    } catch (error) {
      console.log(error);
    }
  }

  setFreezeFirstDrugColumn(shouldFreeze: boolean) {
    DataController.saveFreezeFirstDrugColumn(shouldFreeze);
    this.setState({ freezeFirstDrugColumn: shouldFreeze });
  }

  async getKeepScreenAwake() {
    let shouldKeepAwake = await DataController.getKeepScreenAwake();
    this.setKeepScreenAwake(shouldKeepAwake);

    try {
      const result = await KeepAwake.isSupported();
      if (result.isSupported) {
        this.setState({ keepScreenAwakeSupported: true });
      } else {
        this.setState({ keepScreenAwakeSupported: false });
      }
    } catch (error) {
      console.log(error);
    }

    try {
      RemoteDataController.setUserProperty("keepScreenAwake", "" + shouldKeepAwake);
    } catch (error) {
      console.log(error);
    }
  }

  async setKeepScreenAwake(keepScreenAwake: boolean) {
    DataController.saveKeepScreenAwake(keepScreenAwake);
    this.setState({ keepScreenAwake: keepScreenAwake });

    try {
      const result = await KeepAwake.isSupported();
      if (result.isSupported) {
        if (keepScreenAwake) {
          KeepAwake.keepAwake();
        } else {
          KeepAwake.allowSleep();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  getCurrentSubscription(): IScreenProps["currentSubscription"] {
    let appCanAccessOtherSubscriptions = false;

    let subscriptionValid = false;
    let subscriptionTitle = "";
    let subscriptionDescription = "";
    let subscriptionExpiryDate = null;
    let subscriptionExpiryDisplayDate = "";

    let now = new Date();

    let mostRecentSubscription: IScreenProps["currentSubscription"] = null;

    if (this.state.user) {
      if (this.state.user.isTemporary && this.state.user.temporaryLoginTime) {
        let tempExpiryDate = new Date(this.state.user.temporaryLoginTime);

        let valid = tempExpiryDate > now;

        if (valid === false) {
          setTimeout(() => {
            this.logout(false);
          }, 500);
        }

        mostRecentSubscription = {
          valid: valid,
          title: "Temporary Login",
          description: "",
          expiryDate: tempExpiryDate,
          expiryDisplayDate: format(tempExpiryDate, "do MMMM, yyyy HH:mm:ss"),
          subscriberID: "",
          appData: null,
          app: this.props.hostApp,
        };

        return mostRecentSubscription;
      }

      if (this.state.user.isEPRS) {
        let valid = true;

        mostRecentSubscription = {
          valid: valid,
          title: "Trust Login",
          description: "",
          expiryDate: new Date(0),
          expiryDisplayDate: "N/A",
          subscriberID: "",
          appData: null,
          app: this.props.hostApp,
        };

        return mostRecentSubscription;
      }

      let subscriptions: any = this.state.user.subscriptions;
      let trust = this.state.user.trust;

      if (subscriptions != null && subscriptions.length > 0) {
        for (let subscriptionIndex = 0; subscriptionIndex < subscriptions.length; subscriptionIndex++) {
          let subscription = subscriptions[subscriptionIndex];

          trust = DataController.getTrustFromSubscription(subscription);
          let subscriptionIsForApp = DataController.isSubscriptionForApp(subscription, this.props.hostApp);

          // decide if subscription is allowed (e.g logging into Plus app with iCPG subscription)
          let allowSubscription = false;
          let app: IScreenProps["app"] = this.props.hostApp;

          if (subscriptionIsForApp) {
            if (this.props.hostApp === "iCPG" && trust === "JRCALC") {
              // iCPG app with iCPG subscription
              allowSubscription = true;
              app = "iCPG";
            } else if (this.props.hostApp === "Plus" && trust !== "" && trust !== "JRCALC") {
              // Plus app with trust subscription
              if (trust === this.state.user.trust || this.state.user.trust === "") {
                allowSubscription = true;
                app = "Plus";
              }
            } else if (this.props.hostApp === "CFR") {
              // 1182 // CFR 1 Month Subscription iOS
              // 1183 // CFR 12 Month Subscription iOS
              // 1184 // CFR 1 Month Subscription Android
              // 1185 // CFR 12 Month Subscription Android
              // 1186 // CFR Group Subscription

              let validCFRSubscriptionIDs = [1182, 1183, 1184, 1185, 1186];
              if (validCFRSubscriptionIDs.includes(subscription.SubscriptionID)) {
                allowSubscription = true;
                app = "CFR";
              }
            }
          } else {
            // subscription is for another app
            if (this.props.hostApp === "Plus" && trust === "JRCALC") {
              // Plus app with iCPG subscription
              allowSubscription = true;
              app = "iCPG";
            }
          }

          if (allowSubscription) {
            if (subscription.ExpiryDate != null && subscription.ExpiryDate !== "") {
              let subscriptionExpiryDateString = subscription.ExpiryDate.replace("/Date(", "").replace(")/", "");
              let expiryDateTimestamp = parseInt(subscriptionExpiryDateString);
              let expiryDate = new Date(expiryDateTimestamp);
              let expiryDisplayDate = subscription.DisplayExpiryDate !== "" ? subscription.DisplayExpiryDate : "N/A";

              let subscriptionValid = expiryDate > now || expiryDateTimestamp === 0;

              if (mostRecentSubscription) {
                // there's already a subscription - so check if this one is newer
                if (
                  expiryDate > mostRecentSubscription.expiryDate ||
                  mostRecentSubscription.valid === false ||
                  mostRecentSubscription.app !== this.props.hostApp
                ) {
                  if (mostRecentSubscription.valid && subscriptionValid === false) {
                    continue;
                  }
                  if (app !== this.props.hostApp) {
                    continue;
                  }

                  let appData: IAppData | null = null;
                  if (subscription.App_Data != null) {
                    try {
                      appData = JSON.parse(subscription.App_Data);
                    } catch (error) {
                      console.log("error parsing appData:" + error);
                    }
                  }

                  mostRecentSubscription = {
                    valid: subscriptionValid,
                    title: subscription.Title,
                    description: subscription.Description,
                    expiryDate: expiryDate,
                    expiryDisplayDate: expiryDisplayDate,
                    subscriberID: subscription.SubscriberID,
                    appData: appData,
                    app: app,
                  };
                }
              } else {
                // this is the first subscription found - so set it as the most recent
                let appData: IAppData | null = null;
                if (subscription.App_Data != null) {
                  appData = JSON.parse(subscription.App_Data);
                }

                mostRecentSubscription = {
                  valid: subscriptionValid,
                  title: subscription.Title,
                  description: subscription.Description,
                  expiryDate: expiryDate,
                  expiryDisplayDate: expiryDisplayDate,
                  subscriberID: subscription.SubscriberID,
                  appData: appData,
                  app: app,
                };
              }
            }
          }
        }
      }
      if (this.props.hostApp === "Plus") {
        if (this.props.app === "Plus" && mostRecentSubscription != null && mostRecentSubscription.app === "iCPG") {
          this.props.changeApp("iCPG");
        } else if (
          this.props.app === "iCPG" &&
          mostRecentSubscription != null &&
          mostRecentSubscription.app === "Plus"
        ) {
          this.props.changeApp("Plus");
        }
      }
    }

    return mostRecentSubscription;
  }

  async setupIAP() {
    const productIDs = [
      this.state.oneMonthAndroidProductID,
      this.state.twelveMonthAndroidProductID,
      this.state.oneMonthIOSProductID,
      this.state.twelveMonthIOSProductID,
    ];

    for (let productID of productIDs) {
      try {
        const response = await Subscriptions.getProductDetails({ productIdentifier: productID });

        if (response.data) {
          let product = {
            productId: productID,
            displayName: response.data.displayName,
            description: response.data.description,
            price: response.data.price,
          };

          if (productID === this.state.oneMonthIOSProductID || productID === this.state.oneMonthAndroidProductID) {
            this.setState({
              oneMonthProduct: product,
            });
          }
          if (
            productID === this.state.twelveMonthIOSProductID ||
            productID === this.state.twelveMonthAndroidProductID
          ) {
            this.setState({
              twelveMonthProduct: product,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  async purchaseProduct(product: ISubscriptionProduct) {
    try {
      if ([this.state.oneMonthIOSProductID, this.state.oneMonthAndroidProductID].includes(product.productId)) {
        this.setStateAsync({ purchasingState: "oneMonth" });
      } else if (
        [this.state.twelveMonthIOSProductID, this.state.twelveMonthAndroidProductID].includes(product.productId)
      ) {
        this.setStateAsync({ purchasingState: "twelveMonth" });
      }

      if (isPlatform("ios")) {
        await this.purchaseSubscriptionApple(product);
      } else if (isPlatform("android")) {
        await this.purchaseSubscriptionGoogle(product);
      }

      // workaround to get subscription updated with right expiry date as it didn't work
      setTimeout(async () => {
        await this.downloadAndUpdateUserInfo();

        setTimeout(async () => {
          await this.downloadAndUpdateUserInfo();
        }, 4000);
      }, 4000);
    } catch (error) {
      console.log(error);
    }

    this.setStateAsync({ purchasingState: null });
  }

  async purchaseSubscriptionApple(subscription: ISubscriptionProduct): Promise<void> {
    const response = await Subscriptions.purchaseProduct({ productIdentifier: subscription.productId });

    /**
     * response codes and matching messages:
     * -1: Incompatible with web
     * 0: Successfully purchased product. Successful new purchase OR the user clicked the button despite already owning the product.
     * 1: Could not find a product matching the given productIdentifier
     * 2: Product seems to have been purchased but the transaction failed verification
     * 3: User closed the native popover before purchasing
     * 4: Product request made but is currently pending - likely due to parental restrictions
     * 5: An unknown error occurred whilst in the purchasing process
     */

    if (response.responseCode === 0) {
      const latestTransactionResponse = await Subscriptions.getLatestTransaction({
        productIdentifier: subscription.productId,
      });
      const { productIdentifier, transactionId, expiryDate, originalStartDate } = latestTransactionResponse.data!;

      let transactionDate = Date.now() + "";
      let subscriptionID = -1;
      let endDate = format(addDays(new Date(expiryDate), 1), "yyyy-MM-dd");

      if (this.props.app === "iCPG") {
        if (subscription.productId === this.state.oneMonthIOSProductID) {
          subscriptionID = 5;
        } else if (subscription.productId === this.state.twelveMonthIOSProductID) {
          subscriptionID = 6;
        }
      } else if (this.props.app === "CFR") {
        if (subscription.productId === this.state.oneMonthIOSProductID) {
          subscriptionID = 1182;
        } else if (subscription.productId === this.state.twelveMonthIOSProductID) {
          subscriptionID = 1183;
        }
      }

      if (this.state.user) {
        let sentSuccessfully = await RemoteDataController.sendPurchaseInfo(
          subscriptionID,
          this.state.user,
          transactionDate,
          transactionId,
          subscription.productId,
          endDate
        );
      }
    }
  }

  async purchaseSubscriptionGoogle(subscription: ISubscriptionProduct): Promise<void> {
    Subscriptions.addListener("ANDROID-PURCHASE-RESPONSE", async (response: any) => {
      let shouldClose;

      if (response.successful) {
        let subs: any[] = [];

        try {
          const entitlements = await Subscriptions.getCurrentEntitlements();

          if (entitlements.responseCode === 0 && entitlements.data) {
            // Parse subscriptions to JSON
            subs = JSON.parse(entitlements.data.toString());
          }

          if (subs.length === 0) {
            throw new Error("Can't get latest subscription from Google Play");
          }

          const purchased = subs.find((item) => item.productIdentifier === subscription.productId);

          if (purchased) {
            let transactionDate = Date.now() + "";
            let subscriptionID = -1;
            let endDate = format(addDays(new Date(purchased.expiryDate), 1), "yyyy-MM-dd");

            if (this.props.app === "iCPG") {
              if (subscription.productId === this.state.oneMonthAndroidProductID) {
                subscriptionID = 7;
              } else if (subscription.productId === this.state.twelveMonthAndroidProductID) {
                subscriptionID = 8;
              }
            } else if (this.props.app === "CFR") {
              if (subscription.productId === this.state.oneMonthAndroidProductID) {
                subscriptionID = 1184;
              } else if (subscription.productId === this.state.twelveMonthAndroidProductID) {
                subscriptionID = 1185;
              }
            }

            if (this.state.user) {
              let sentSuccessfully = await RemoteDataController.sendPurchaseInfo(
                subscriptionID,
                this.state.user,
                transactionDate,
                purchased.transactionId,
                subscription.productId,
                endDate
              );
            }
          }
        } catch (error) {
          console.log("Error getting subscriptions from Google Play: ", error);
          subs = [];
        }
      }
    });

    await Subscriptions.purchaseProduct({ productIdentifier: subscription.productId });
  }

  async manageSubscriptions() {
    Subscriptions.manageSubscriptions();
  }

  async restorePurchases() {
    try {
      // can potentially have a lot of purchases to restore - but only interested in sending 1 per product as the correct expiry date will still be retrieved.
      if (this.state.user) {
        var now = new Date();
        var logTime = now.toISOString();
        RemoteDataController.logSubscriptionRestorationInfo(
          logTime + "- UID: " + this.state.user.uid + " - starting to restore purchases"
        );
      }

      await this.setStateAsync({ purchasingState: "restoring" });

      const entitlements = await RemoteDataController.restoreSubscription();

      if (entitlements.success) {
        // console.log(entitlements.subs);
        if (entitlements.subs.length > 0) {
          const latest = entitlements.subs[0];

          if (
            latest &&
            latest.startDate &&
            latest.transactionId &&
            latest.productId &&
            latest.endDate &&
            this.state.user != null
          ) {
            let productID = latest.productId;
            let subscriptionID = -1;
            let endDate = format(addDays(new Date(latest.endDate), 1), "yyyy-MM-dd");

            if (this.props.app === "iCPG") {
              if (productID === this.state.oneMonthIOSProductID) {
                subscriptionID = 5;
              } else if (productID === this.state.twelveMonthIOSProductID) {
                subscriptionID = 6;
              } else if (productID === this.state.oneMonthAndroidProductID) {
                subscriptionID = 7;
              } else if (productID === this.state.twelveMonthAndroidProductID) {
                subscriptionID = 8;
              }
            } else if (this.props.app === "CFR") {
              if (productID === this.state.oneMonthIOSProductID) {
                subscriptionID = 1182;
              } else if (productID === this.state.twelveMonthIOSProductID) {
                subscriptionID = 1183;
              } else if (productID === this.state.oneMonthAndroidProductID) {
                subscriptionID = 1184;
              } else if (productID === this.state.twelveMonthAndroidProductID) {
                subscriptionID = 1185;
              }
            }

            const success = await RemoteDataController.sendPurchaseInfo(
              subscriptionID,
              this.state.user,
              latest.startDate,
              latest.transactionId,
              latest.productId,
              endDate
            );

            await this.downloadAndUpdateUserInfo();

            if (success) {
              alert("Successfully restored purchases");
            } else {
              alert("An error occurred when restored purchases");
            }
          } else {
            alert("No purchases to restore");
          }
        } else {
          alert("Found no purchases to restore");
        }
      } else {
        alert("An error occurred when restored purchases");
      }

      await this.setStateAsync({ purchasingState: null });
    } catch (error) {
      console.log("error restoring purchases");
      console.log(error);
      await this.setStateAsync({ purchasingState: null });
    }
  }

  async sendSupportEmail(
    type: "Subscription Support" | "Feedback" | "Delete Account" | "Search Suggestion",
    params?: any
  ) {
    let toAddress = "apps@class.co.uk";
    let ccAddress = "";
    let subject = "Support";
    let emailBody = "";

    if (type === "Subscription Support") {
      toAddress = "apps@class.co.uk";
      subject = "Support";
    } else if (type === "Feedback") {
      toAddress = "apps@class.co.uk";
      subject = "Feedback";
    } else if (type === "Delete Account") {
      toAddress = "apps@class.co.uk";
      subject = DataController.getAppDisplayName(this.props.app) + " account deletion request";
    } else if (type === "Search Suggestion") {
      toAddress = "apps@class.co.uk";
      subject = DataController.getAppDisplayName(this.props.app) + " search suggestion";
    }

    try {
      let deviceInfo = await Device.getInfo();

      let sendHtmlEmail = false;
      // if ((isPlatform('ios') || isPlatform('android')) && !isPlatform('mobileweb')) {
      //   let hasNativeEmailAccount = await EmailComposer.hasAccount();
      //   sendHtmlEmail = hasNativeEmailAccount.hasAccount;
      // }

      let currentSubscription = this.getCurrentSubscription();
      let subscriptionTitle = "";
      let subscriptionDescription = "";
      let subscriptionExpiryDisplayDate = "";

      if (currentSubscription) {
        subscriptionTitle = currentSubscription.title;
        subscriptionDescription = currentSubscription.description;
        subscriptionExpiryDisplayDate = currentSubscription.expiryDisplayDate;
      }

      if (sendHtmlEmail) {
        if (type === "Search Suggestion") {
          emailBody += '<div style="color:darkslategrey">Search suggestion: ' + params + "</div>";
          emailBody += '<div style="color:darkslategrey">Please suggest what you would like to see: </div>';
        } else {
          emailBody += '<div style="padding-bottom:20px">Type your query here</div>';
          emailBody += "<hr>";
          emailBody += '<div style="color:darkslategrey">Device and subscription info below</div>';

          if (this.state.user) {
            emailBody += '<div style="color:darkslategrey">User: ' + this.state.user.email + "</div>";
            emailBody += '<div style="color:darkslategrey">UserID: ' + this.state.user.uid + "</div>";
          } else {
            emailBody += '<div style="color:darkslategrey">User: Not logged in</div>';
          }

          if (deviceInfo != null) {
            let appVersion = await DataController.getAppVersion(this.props.app);

            emailBody +=
              '<div style="color:darkslategrey">App: ' + DataController.getAppDisplayName(this.props.app) + "</div>";
            emailBody += '<div style="color:darkslategrey">App Version: ' + appVersion + "</div>";
            emailBody += '<div style="color:darkslategrey">Device Manufacturer: ' + deviceInfo.manufacturer + "</div>";
            emailBody += '<div style="color:darkslategrey">Device Model: ' + deviceInfo.model + "</div>";
            emailBody += '<div style="color:darkslategrey">Platform: ' + deviceInfo.platform + "</div>";
            emailBody += '<div style="color:darkslategrey">OS Version: ' + deviceInfo.osVersion + "</div>";
            emailBody += '<div style="color:darkslategrey">WebView Version: ' + deviceInfo.webViewVersion + "</div>";
          }

          if (this.state.user) {
            emailBody += '<div style="color:darkslategrey">Token: ' + this.state.user.token + "</div>";
          }

          emailBody += "<br/>";

          emailBody += '<div style="color:darkslategrey">Subscription Info</div>';

          if (currentSubscription != null) {
            emailBody += '<div style="color:darkslategrey">Title: ' + subscriptionTitle + "</div>";
            emailBody += '<div style="color:darkslategrey">Description: ' + subscriptionDescription + "</div>";
            emailBody += '<div style="color:darkslategrey">Expiry Date: ' + subscriptionExpiryDisplayDate + "</div>";
          } else {
            emailBody += '<div style="color:darkslategrey">No subscription</div>';
          }
        }

        EmailComposer.open({
          to: [toAddress],
          cc: [ccAddress],
          subject: subject,
          body: emailBody,
          isHtml: true,
        });
      } else {
        let appVersion = await DataController.getAppVersion(this.props.app);

        if (type === "Search Suggestion") {
          emailBody += "Search term: " + params + "\n";
          emailBody += "Please suggest what you would like to see: \n\n";
        } else {
          emailBody += "Type your query here\n\n";
          emailBody += "Device and subscription info below\n";
          if (this.state.user) {
            emailBody += "User: " + this.state.user.email + "\n";
            emailBody += "UserID: " + this.state.user.uid + "\n";
          } else {
            emailBody += "User: Not logged in\n";
          }

          if (deviceInfo != null) {
            emailBody += "App: " + DataController.getAppDisplayName(this.props.app) + "\n";
            emailBody += "App Version: " + appVersion + "\n";
            emailBody += "Device Manufacturer: " + deviceInfo.manufacturer + "\n";
            emailBody += "Device Model: " + deviceInfo.model + "\n";
            emailBody += "Platform: " + deviceInfo.platform + "\n";
            emailBody += "OS Version: " + deviceInfo.osVersion + "\n";
            emailBody += "WebView Version: " + deviceInfo.webViewVersion + "\n";
          }
          if (this.state.user) {
            emailBody += "Token: " + this.state.user.token + "\n";
          }
          emailBody += "\n";

          emailBody += "Subscription Info\n";

          if (currentSubscription != null) {
            emailBody += "Title: " + subscriptionTitle + "\n";
            emailBody += "Description: " + subscriptionDescription + "\n";
            emailBody += "Expiry Date: " + subscriptionExpiryDisplayDate + "\n";
          } else {
            emailBody += "No subscription\n";
          }
        }

        emailBody = emailBody.replace(/\n/g, "%0D%0A");

        let mailtoLink = "mailto:" + toAddress + "?";
        if (ccAddress !== "") {
          mailtoLink += "cc=" + ccAddress + "&";
        }
        mailtoLink += "subject=" + subject + "&body=" + emailBody;

        // creating link and clicking it - as window.open on mailto link was causing crash
        var link = document.createElement("a");
        link.href = mailtoLink;
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener");
        link.click();
      }
    } catch (error) {
      console.log(error);
      // create basic formatted email without subscription info
      window.open("mailto:" + toAddress + "?subject=" + subject + "&body=" + emailBody, "_blank", "noreferrer");
    }

    if (type === "Subscription Support") {
      RemoteDataController.logEvent("send_support_email", {});
    } else if (type === "Feedback") {
      RemoteDataController.logEvent("send_feedback", {});
    }
  }

  showOlark(shouldShow: boolean) {
    try {
      if (shouldShow) {
        // @ts-ignore
        olark("api.box.expand");
        // @ts-ignore
        olark("api.box.onShrink", () => {
          // @ts-ignore
          olark("api.box.hide");
        });

        let operatorNotificationMessage = "";
        if (this.state.user != null) {
          operatorNotificationMessage = `ContactID: ${this.state.user.uid}, Email: ${this.state.user.email}`;
        }

        // @ts-ignore
        olark("api.chat.onBeginConversation", function () {
          // Notifies the operator - the visitor does not see this

          // @ts-ignore
          olark("api.chat.sendNotificationToOperator", {
            body: operatorNotificationMessage,
          });
        });
      } else {
        // @ts-ignore
        olark("api.box.hide");
      }
    } catch (error) {
      console.log("Error with Olark", error);
    }
  }

  handleOnAction(event: any) {
    // console.log('user did something', event)
  }

  handleOnActive(event: any) {
    // console.log('user is active', event)
    // console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  async handleOnIdle(event: any) {
    // console.log('user is idle', event)
    // console.log('last active', this.idleTimer.getLastActiveTime())
    let shouldLogout = false;

    if (this.state.user != null) {
      if ((isPlatform("ios") || isPlatform("android")) && isPlatform("mobileweb") === false) {
        // native mobile
        if (this.state.features.includes("idleLogoutMobile")) {
          shouldLogout = true;
        }
      } else if (DataController.isDesktopVersion()) {
        // desktop
        let desktopConfig = await this.getDesktopConfig();

        if (desktopConfig != null) {
          if (desktopConfig.idleLogoutTimer != null && desktopConfig.idleLogoutTimer > 0) {
            shouldLogout = true;
          }
        }
      } else {
        // web
        if (this.state.features.includes("idleLogoutWeb")) {
          shouldLogout = true;
        }
      }
    }

    if (shouldLogout) {
      this.logout(false);
      setTimeout(() => {
        alert("Signed out as you've been inactive for an while");
      }, 1000);
    }
  }

  setStateAsync(state: any) {
    return new Promise((resolve: any) => {
      this.setState(state, resolve);
    });
  }

  async waitForContentsToLoad() {
    return new Promise((resolve: any) => {
      if (this.state.messageBarText !== "Loading content") {
        resolve();
        return;
      }
      const interval = setInterval(async () => {
        if (this.state.messageBarText !== "Loading content") {
          clearInterval(interval);
          resolve();
        }
      }, 500);
    });
  }

  async waitForRouterToLoad() {
    return new Promise((resolve: any) => {
      if (this.reactRouter && this.reactRouter.current && this.reactRouter.current.history != null) {
        resolve();
        return;
      }
      const interval = setInterval(async () => {
        if (this.reactRouter && this.reactRouter.current && this.reactRouter.current.history != null) {
          clearInterval(interval);
          resolve();
        }
      }, 500);
    });
  }

  async canDismissAccountSwitcherModal(data?: any, role?: string) {
    return role !== "gesture";
  }

  render() {
    let app = this.props.app;
    let accountModalOpen = this.state.accountModalOpenedByUser;

    // filter further resources
    let filteredFurtherResources: IFurtherResource[] = [];

    for (
      let furtherResourceIndex = 0;
      furtherResourceIndex < this.state.furtherResources.length;
      furtherResourceIndex++
    ) {
      let furtherResource = this.state.furtherResources[furtherResourceIndex];

      if (furtherResource.enabled) {
        if (furtherResource.products.includes(app) || furtherResource.products.includes("ALL")) {
          if (app === "iCPG" || furtherResource.trusts.includes("ALL")) {
            filteredFurtherResources.push(furtherResource);
          } else if (this.state.user != null && furtherResource.trusts.includes(this.state.user.trust)) {
            filteredFurtherResources.push(furtherResource);
          }
        }
      }
    }

    // filter helpCentreItems
    let filteredHelpCentreItems: IHelpCentreItem[] = [];

    for (let helpCentreItemIndex = 0; helpCentreItemIndex < this.state.helpCentreItems.length; helpCentreItemIndex++) {
      let helpCentreItem = this.state.helpCentreItems[helpCentreItemIndex];

      if (helpCentreItem.enabled === false) {
        continue;
      } else if (helpCentreItem.app.includes(app) === false) {
        continue;
      } else if (helpCentreItem.trusts != null && helpCentreItem.trusts.length > 0) {
        if (this.state.user != null && helpCentreItem.trusts.includes(this.state.user.trust) === false) {
          continue;
        }
      }

      if (helpCentreItem.enabled) {
        if (helpCentreItem.app.includes(app)) {
          filteredHelpCentreItems.push(helpCentreItem);
        }
      }
    }

    // check if subscription is valid - if not then show account screen
    let currentSubscription = this.getCurrentSubscription();

    if (this.state.user != null && (currentSubscription == null || currentSubscription.valid === false)) {
      accountModalOpen = true;
    }

    // build list of remembered users for user switching
    let rememberedUsersLayout = [];
    if (this.state.showAccountSwitcher) {
      for (
        let rememberedUserIndex = 0;
        rememberedUserIndex < this.state.rememberedUsers.length;
        rememberedUserIndex++
      ) {
        let rememberedUser = this.state.rememberedUsers[rememberedUserIndex];

        let availableTrustsLayout = [];

        for (
          let availableTrustsIndex = 0;
          availableTrustsIndex < rememberedUser.availableTrusts.length;
          availableTrustsIndex++
        ) {
          let availableTrust = rememberedUser.availableTrusts[availableTrustsIndex];

          availableTrustsLayout.push(
            <div
              key={`user-${rememberedUser.uid}-${availableTrust}`}
              className="accountSwitcherTrustRow"
              onClick={this.switchAccount.bind(this, rememberedUser, availableTrust)}
            >
              <div className="accountSwitcherTrust">
                <div>{DataController.getTrustDisplayName(availableTrust)}</div>
              </div>
              <div>
                {this.state.user &&
                this.state.user.uid === rememberedUser.uid &&
                this.state.user.trust === availableTrust ? (
                  <img
                    alt=""
                    className="icon-44 accountSwitcherTickIcon"
                    src={this.state.darkMode ? iconTickDark : iconTickDark}
                  />
                ) : null}
              </div>
            </div>
          );
        }
        rememberedUsersLayout.push(
          <div className="accountSwitcherUser">
            <div
              key={`user-${rememberedUser.uid}`}
              className="accountSwitcherRow"
              onClick={this.switchAccount.bind(this, rememberedUser, "")}
            >
              <div className={`accountSwitcherEmail ${this.props.app === "iCPG" ? "accountSwitcherEmailiCPG" : ""}`}>
                <div>{rememberedUser.email}</div>
              </div>
            </div>
            {availableTrustsLayout}
          </div>
        );
      }
    }

    const screenProps: IScreenProps = {
      /* app specific props */
      app: app,
      hostApp: this.props.hostApp,
      /* general props */
      user: this.state.user,
      rememberedUsers: this.state.rememberedUsers,
      userUpdated: this.userUpdated.bind(this),
      trust: this.state.trust,
      guidelineSummaries: this.state.guidelineSummaries,
      algorithms: this.state.algorithms,
      algorithmOnlyGuidelineSummaries: this.state.algorithmOnlyGuidelineSummaries,
      annotations: this.state.annotations,
      trustGuidelineSummariesWithAlgorithms: this.state.trustGuidelineSummariesWithAlgorithms,
      images: this.state.images,
      bookmarks: this.state.bookmarks,
      saveBookmark: this.saveBookmark.bind(this),
      recentlyViewed: this.state.recentlyViewed,
      saveRecentlyViewed: this.saveRecentlyViewed.bind(this),
      isGuidelineUpdated: this.isGuidelineUpdated.bind(this),
      updateGuidelineLastOpenedVersion: this.updateGuidelineLastOpenedVersion.bind(this),
      patientAge: this.state.patientAge,
      furtherResources: filteredFurtherResources,
      significantChanges: this.state.significantChanges,
      significantChangeAcks: this.state.significantChangeAcks,
      clinicalNotices: this.state.clinicalNotices,
      clinicalNoticeAcks: this.state.clinicalNoticeAcks,
      pgdAcks: this.state.pgdAcks,
      glAcks: this.state.glAcks,
      notifications: this.state.notifications,
      notificationCount: this.state.notificationCount,
      trendingSearches: this.state.trendingSearches,
      pathwayData: this.state.pathwayData,
      pgdTrustInfo: this.state.pgdTrustInfo,
      trustPins: this.state.trustPins,
      regions: this.state.regions,
      staffGroups: this.state.staffGroups,
      restrictedSections: this.state.restrictedSections,
      helpCentreItems: filteredHelpCentreItems,
      trustInfo: this.state.trustInfo,
      sectionColors: this.state.sectionColors,
      appNotice: this.state.appNotice,
      essentialSections: this.state.essentialSections,
      notificationClicked: this.notificationClicked.bind(this),
      markNotificationsAsRead: this.markNotificationsAsRead.bind(this),
      acknowledgeClinicalNotice: this.acknowledgeClinicalNotice.bind(this),
      acknowledgeSignificantChange: this.acknowledgeSignificantChange.bind(this),
      acknowledgePGD: this.acknowledgePGD.bind(this),
      checkPGDRemoteStatus: this.checkPGDRemoteStatus.bind(this),
      acknowledgeGuideline: this.acknowledgeGuideline.bind(this),
      updatePatientAge: this.updatePatientAge.bind(this),
      navigateToGuideline: this.navigateToGuideline.bind(this),
      navigateToAlgorithm: this.navigateToAlgorithm.bind(this),
      navigateToClinicalNotice: this.navigateToClinicalNotice.bind(this),
      navigateToPathway: this.navigateToPathway.bind(this),
      navigateToEssentialSection: this.navigateToEssentialSection.bind(this),
      navigateToTrustPinsList: this.navigateToTrustPinsList.bind(this),
      takeParaPassQuiz: this.takeParaPassQuiz.bind(this),
      takeParaPassPGDQuiz: this.takeParaPassPGDQuiz.bind(this),
      guidelineTextFinishedLoading: this.state.guidelineTextFinishedLoading,
      getGuidelineText: this.getGuidelineText.bind(this),
      getClinicalNoticeText: this.getClinicalNoticeText.bind(this),
      getEssentialsText: this.getEssentialsText.bind(this),
      showAccountModal: this.showAccountModal.bind(this),
      showAddAccountLoginModal: this.showAddAccountLoginModal.bind(this),
      showHelpCentre: this.showHelpCentre.bind(this),
      showContactPage: this.showContactPage.bind(this),
      showTabBar: this.showTabBar.bind(this),
      showStatusBar: this.showStatusBar.bind(this),
      tabBarVisible: this.state.tabBarVisible,
      fontSizeChange: this.state.fontSizeChange,
      increaseFontSize: this.increaseFontSize.bind(this),
      decreaseFontSize: this.decreaseFontSize.bind(this),
      resetFontSize: this.resetFontSize.bind(this),
      lineHeightChange: this.state.lineHeightChange,
      increaseLineHeight: this.increaseLineHeight.bind(this),
      decreaseLineHeight: this.decreaseLineHeight.bind(this),
      resetLineHeight: this.resetLineHeight.bind(this),
      selectedFontFamily: this.state.selectedFontFamily,
      setSelectedFontFamily: this.setSelectedFontFamily.bind(this),
      showTextToSpeech: this.state.showTextToSpeech,
      setShowTextToSpeech: this.setShowTextToSpeech.bind(this),
      textToSpeechSpeed: this.state.textToSpeechSpeed,
      setTextToSpeechSpeed: this.setTextToSpeechSpeed.bind(this),
      darkMode: this.state.darkMode,
      appearance: this.state.appearance,
      setAppearance: this.setAppearance.bind(this),
      showColorFilter: this.state.showColorFilter,
      setShowColorFilter: this.setShowColorFilter.bind(this),
      filterColor: this.state.filterColor,
      setFilterColor: this.setFilterColor.bind(this),
      freezeFirstDrugColumn: this.state.freezeFirstDrugColumn,
      setFreezeFirstDrugColumn: this.setFreezeFirstDrugColumn.bind(this),
      keepScreenAwake: this.state.keepScreenAwake,
      setKeepScreenAwake: this.setKeepScreenAwake.bind(this),
      keepScreenAwakeSupported: this.state.keepScreenAwakeSupported,
      fontWeight: this.state.fontWeight,
      setFontWeight: this.setFontWeight.bind(this),
      accessabilityUnderlineLinks: this.state.accessabilityUnderlineLinks,
      setAccessabilityUnderlineLinks: this.setAccessabilityUnderlineLinks.bind(this),
      hideParaPassLinks: this.state.hideParaPassLinks,
      setHideParaPassLinks: this.setHideParaPassLinks.bind(this),
      lowVisMode: this.state.lowVisMode,
      setLowVisMode: this.setLowVisMode.bind(this),
      testMode: this.state.testMode,
      debugMode: this.state.debugMode,
      abTestingVersion: this.state.abTestingVersion,
      showAccountSwitcher: this.showAccountSwitcher.bind(this),
      switchAccount: this.switchAccount.bind(this),
      toggleTestMode: this.toggleTestMode.bind(this),
      toggleDebugMode: this.toggleDebugMode.bind(this),
      networkStatus: this.state.networkStatus,
      messageBarText: this.state.messageBarText,
      loadData: this.loadData.bind(this),
      currentSubscription: currentSubscription,
      oneMonthProduct: this.state.oneMonthProduct,
      twelveMonthProduct: this.state.twelveMonthProduct,
      purchaseProduct: this.purchaseProduct.bind(this),
      restorePurchases: this.restorePurchases.bind(this),
      purchasingState: this.state.purchasingState,
      manageSubscriptions: this.manageSubscriptions.bind(this),
      sendSupportEmail: this.sendSupportEmail.bind(this),
      logout: this.logout.bind(this),
      setAppHistory: this.setAppHistory.bind(this),
      finishOnboarding: this.finishOnboarding.bind(this),
      requestAccountDeletion: this.requestAccountDeletion.bind(this),
      updateStaffGroups: this.updateStaffGroups.bind(this),
      updateRegions: this.updateRegions.bind(this),
      openParaPass: this.openParaPass.bind(this),
      openParaFolio: this.openParaFolio.bind(this),
      showOlark: this.showOlark.bind(this),
      getGuidelineTitleForLogging: this.getGuidelineTitleForLogging.bind(this),
    };

    return (
      <IonApp>
        <IdleTimer
          ref={(ref: any) => {
            this.idleTimer = ref;
          }}
          timeout={this.state.idleTimeout}
          onActive={this.handleOnActive.bind(this)}
          onIdle={this.handleOnIdle.bind(this)}
          onAction={this.handleOnAction.bind(this)}
          debounce={250}
        />
        <IonModal
          isOpen={accountModalOpen}
          id="accountModal"
          onDidDismiss={() => this.showAccountModal(false)}
          backdropDismiss={false}
        >
          <AccountPage features={this.state.features} screenProps={screenProps} />
          <div className="appColorOverlay" />
        </IonModal>
        <IonModal
          isOpen={this.state.addAccountLoginModalOpen}
          id="accountModal"
          onDidDismiss={() => this.showAddAccountLoginModal(false)}
        >
          <LoginPage addingAccount={true} features={this.state.features} screenProps={screenProps} />
          <div className="appColorOverlay" />
        </IonModal>
        <IonPopover
          id="temporaryLoginModal"
          showBackdrop={true}
          isOpen={this.state.showTemporarilyLoginNotice}
          onDidDismiss={() => this.setState({ showTemporarilyLoginNotice: false })}
        >
          <div className="temporaryLoginNotice">
            <div className="temporaryLoginNoticeTitle">Temporary Login</div>
            <div className="temporaryLoginNoticeDescription">
              You are currently signed in using a temporary login. You can view the current server status on the account
              page.
            </div>
            <IonButton className="filledButton" onClick={() => this.setState({ showTemporarilyLoginNotice: false })}>
              Continue
            </IonButton>
          </div>
        </IonPopover>
        <IonModal isOpen={this.state.showOnboarding} id="onboardingModal" onDidDismiss={() => this.finishOnboarding()}>
          <OnboardingPage features={this.state.features} screenProps={screenProps} />
          <div className="appColorOverlay" />
        </IonModal>

        {this.props.app === "CFR" ? (
          <IonModal
            isOpen={this.state.cfrDisclaimerModalOpen}
            backdropDismiss={false}
            id="cfrDisclaimerPopover"
            mode="md"
          >
            <IonContent>
              <div className="cfrDashboardHeaderDivDisclaimer">
                <img className="cfrDisclaimerLogo" src={responderLogo} />
                <div className="cfrDisclaimerHeaderText">RESPONDER</div>
                <div className="cfrDisclaimerPlusText">PLUS</div>
              </div>
              <div>
                <span className="cfrDisclaimerTitle">{"Disclaimer"}</span>
                <span className="cfrDisclaimerText">
                  {"The Responder Plus app is for information purposes. Responders must " +
                    "practise according to the local policies of your organisation. Do not carry out " +
                    "procedures unless they are within your scope of practice."}
                </span>
              </div>
              <div className="cfrDisclaimerButton">
                <IonButton className="filledButton" mode="ios" onClick={this.cfrDisclaimerDismissed.bind(this)}>
                  <IonLabel mode="ios">{"OK"}</IonLabel>
                </IonButton>
              </div>
            </IonContent>
            <div className="appColorOverlay" />
          </IonModal>
        ) : null}

        <IonReactRouter ref={this.reactRouter}>
          <Switch>
            <Route
              path="/"
              render={(props) => {
                if (this.state.user) {
                  return (
                    <AppStack
                      key={this.state.user.uid + this.state.user.trust}
                      {...props}
                      features={this.state.features}
                      screenProps={screenProps}
                    />
                  );
                } else {
                  return (
                    <LoginPage
                      {...props}
                      addingAccount={false}
                      features={this.state.features}
                      screenProps={screenProps}
                    />
                  );
                }
              }}
            />
            <Route exact path="/" render={() => <Redirect to="/" />} />
          </Switch>
        </IonReactRouter>
        <IonModal
          id="accountSwitcherModal"
          isOpen={this.state.showAccountSwitcher}
          onDidDismiss={() => this.showAccountSwitcher(false)}
          mode="ios"
          showBackdrop={true}
          initialBreakpoint={1}
          breakpoints={[0, 1]}
          backdropDismiss={true}
          handle={false}
          canDismiss={this.canDismissAccountSwitcherModal.bind(this)}
        >
          <div>
            <div>
              <div className="filterHeader">
                <div />
                <div>Switch Account</div>
                <IonButton className="clearButton toolbarButton" onClick={this.showAccountSwitcher.bind(this, false)}>
                  <img className="icon-44" src={iconClose} />
                </IonButton>
              </div>

              <div className="accountSwitcherContent">
                {rememberedUsersLayout}
                {this.state.user !== null ? (
                  <div className="accountSwitcherAddAccount" onClick={this.showAddAccountLoginModal.bind(this, true)}>
                    <img alt="" className="icon-44" src={this.state.darkMode ? iconAddDark : iconAdd} />
                    Add account
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </IonModal>
        {/* {this.state.showAccountSwitcher ? (
          <div className={"bottomSheetContainer"}>
            <div
              onClick={this.showAccountSwitcher.bind(this, false)}
              className={`bottomSheetBackdrop ${this.state.showAccountSwitcher ? "active" : ""}`}
            />
            <div className={`bottomSheet ${this.state.showAccountSwitcher ? "active" : ""}`}>
              <div className="filterHeader">
                <div />
                <div>Switch Account</div>
                <IonButton className="clearButton toolbarButton" onClick={this.showAccountSwitcher.bind(this, false)}>
                  <img className="icon-44" src={iconClose} />
                </IonButton>
              </div>

              <div className="accountSwitcherContent">
                {rememberedUsersLayout}
                {this.state.user !== null ? (
                  <div className="accountSwitcherAddAccount" onClick={this.showAddAccountLoginModal.bind(this, true)}>
                    <img alt="" className="icon-44" src={this.state.darkMode ? iconAddDark : iconAdd} />
                    Add account
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null} */}
        <div className="appColorOverlay" />
        <IonAlert
          buttons={[
            "No, cancel request",
            { text: "Yes, request account deletion", handler: this.sendAccountDeletionRequest.bind(this) },
          ]}
          isOpen={this.state.showAccountDeletionAlert}
          onDidDismiss={() => this.showAccountDeletionAlert(false)}
          header={"Are you sure you want to request your account to be deleted?"}
          message={
            "Tapping 'Yes, request account deletion' will alert our support team to delete your account. Our support team will deal with your request within a few days and you will be notified once your account has successfully been deleted. Please note that deleting your account will not cancel your subscription automatically. To do this you will need to go to the Settings app and manage your subscription from there."
          }
        />

        {this.state.user != null ? <MessageBar messageBarText={this.state.messageBarText} /> : null}
      </IonApp>
    );
  }
}

export default SharedApp;
